(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ayc-e-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const registry = window.__aycECatalogInstances || (window.__aycECatalogInstances = new Map());

    function initializeAycCatalog(sectionElement) {
      if (!sectionElement || !sectionElement.querySelector) return;
      const rootElement = sectionElement.querySelector('[data-ayc-ecat-root]');
      if (!rootElement || rootElement.dataset.aycEcatInitialized === 'true') return;

      const sectionKey = rootElement.dataset.sectionId || sectionElement.id || 'ayc-e-catalog';
      registry.get(sectionKey)?.destroy?.();
      rootElement.dataset.aycEcatInitialized = 'true';

      const lifecycleController = new AbortController();
      let destroyed = false;
      const getById = (id) => sectionElement.querySelector(`#${CSS.escape(id)}`);

      let pdfjsLib = null;

      async function getPdfJs() {
        if (pdfjsLib) return pdfjsLib;
        pdfjsLib = await import('https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.min.mjs');
        pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.10.38/build/pdf.worker.min.mjs';
        return pdfjsLib;
      }

      /* ================================================================
       VERSIONED CATALOG CONFIGURATION

       index.html no longer contains page paths or page counts. It reads:

         catalog-config.json
           -> catalogs/<version>/catalog.json
           -> pages/page-001.png
           -> pages-hd/page-001.png
           -> catalog.pdf (optional)

       To publish a new catalog, upload a new version folder and change only
       activeCatalog in catalog-config.json. The previous version remains
       available for immediate rollback and receives a different URL, avoiding
       stale browser/CDN image caches.

       For Shopify/CDN hosting, CATALOG_CONFIG_URL may be a complete HTTPS URL.
       For local testing, run an HTTP server instead of opening file:// directly.
       ================================================================ */
      const CATALOG_CONFIG_URL = 'shopify-inline';

      let activeCatalogConfig = null;
      let activeCatalogConfigUrl = '';
      let PAGE_IMAGE_URLS = [];
      let PAGE_IMAGE_TEMPLATE = '';
      let PAGE_IMAGE_COUNT = 0;
      let PAGE_IMAGE_PADDING = 3;
      let HD_PAGE_IMAGE_URLS = [];
      let HD_PAGE_IMAGE_TEMPLATE = '';
      let HD_PAGE_IMAGE_COUNT = 0;
      let HD_PAGE_IMAGE_PADDING = 3;
      let PDF_URL = '';

      const els = {
        root: getById('ayc-ecat-root'),
        book: getById('ayc-ecat-book'),
        originalSpread: getById('ayc-ecat-original-spread'),
        persistentSpine: getById('ayc-ecat-persistent-spine'),
        originalLeft: getById('ayc-ecat-original-left'),
        originalRight: getById('ayc-ecat-original-right'),
        originalLeftImage: getById('ayc-ecat-original-left-image'),
        originalRightImage: getById('ayc-ecat-original-right-image'),
        bookStage: getById('ayc-ecat-book-stage'),
        bookRow: document.querySelector('.ayc-ecat-book-row'),
        viewerShell: document.querySelector('.ayc-ecat-viewer-shell'),
        viewerState: getById('ayc-ecat-viewer-state'),
        stateTitle: getById('ayc-ecat-state-title'),
        stateMessage: getById('ayc-ecat-state-message'),
        prevButton: getById('ayc-ecat-prev-button'),
        nextButton: getById('ayc-ecat-next-button'),
        pageRange: getById('ayc-ecat-page-range'),
        pageStatus: getById('ayc-ecat-page-status'),
        pageCount: getById('ayc-ecat-page-count'),
        fileSize: getById('ayc-ecat-file-size'),
        printButton: getById('ayc-ecat-print-button'),
        downloadButton: getById('ayc-ecat-download-button'),
        copyButton: getById('ayc-ecat-copy-button'),
        zoomButton: getById('ayc-ecat-zoom-button'),
        fullscreenButton: getById('ayc-ecat-fullscreen-button'),
        hdViewer: getById('ayc-ecat-hd-viewer'),
        hdViewport: getById('ayc-ecat-hd-viewport'),
        hdCanvas: getById('ayc-ecat-hd-canvas'),
        hdImage: getById('ayc-ecat-hd-image'),
        hdLoading: getById('ayc-ecat-hd-loading'),
        hdLoadingText: getById('ayc-ecat-hd-loading-text'),
        hdPageStatus: getById('ayc-ecat-hd-page-status'),
        hdZoomValue: getById('ayc-ecat-hd-zoom-value'),
        hdZoomOut: getById('ayc-ecat-hd-zoom-out'),
        hdZoomIn: getById('ayc-ecat-hd-zoom-in'),
        hdReset: getById('ayc-ecat-hd-reset'),
        hdClose: getById('ayc-ecat-hd-close'),
        hdPrev: getById('ayc-ecat-hd-prev'),
        hdNext: getById('ayc-ecat-hd-next'),
        catalogNav: getById('ayc-ecat-catalog-nav'),
        issueLabel: getById('ayc-ecat-issue-label'),
        catalogTitle: getById('ayc-ecat-catalog-title'),
        companyName: getById('ayc-ecat-company-name'),
        catalogDescription: getById('ayc-ecat-catalog-description'),
        updatedValue: getById('ayc-ecat-updated-value'),
        brandsValue: getById('ayc-ecat-brands-value'),
        contentsSection: getById('ayc-ecat-contents'),
        contentsList: getById('ayc-ecat-contents-list'),
        toast: getById('ayc-ecat-toast'),
      };

      let pdfDocument = null;
      let pageFlip = null;
      let totalPages = 0;
      let currentPage = 1;
      let pageRatio = 0.72;
      let renderWidth = 648;
      let renderHeight = 900;
      let downloadedBytes = 0;
      let resolvedPdfUrl = '';
      let catalogFileName = 'catalog.pdf';
      let configuredDownloadFileName = '';
      let toastTimer = null;
      let turnLock = false;
      let turnUnlockTimer = null;
      let lastPrimeKey = '';
      let backgroundPreloadCursor = 1;
      let backgroundPreloadStarted = false;
      let backgroundPreloadQueue = [];
      let pageImageUrls = [];
      let fallbackRefreshRunning = false;
      let fallbackRefreshNeeded = false;
      let pendingCanvasPatches = new Map();
      let bookFrameWidth = 0;
      let bookFrameHeight = 0;
      let layoutSyncTimer = null;
      let layoutSyncPending = false;
      let settleFrameQueued = false;
      let bookResizeObserver = null;
      let lastObservedStageWidth = 0;
      let lastObservedStageHeight = 0;
      let layoutSyncRunning = false;
      let gestureLoadPromise = null;
      let sharedBlankPageUrl = '';
      let directPageImageUrls = [];
      let hdPageImageUrls = [];
      let directImageMode = false;
      let pdfSupportLoading = null;
      let hdViewerOpen = false;
      let hdViewerPage = 1;
      let hdViewerZoom = 1;
      let hdViewerMaxZoom = 1;
      let hdFitWidth = 0;
      let hdFitHeight = 0;
      let hdLoadToken = 0;
      let hdResizeTimer = null;
      let hdBodyOverflowBeforeOpen = '';
      let hdPanState = null;
      let originalSpreadToken = 0;
      let originalSpreadKey = '';
      const hdImageCache = new Map();

      const INITIAL_PRELOAD_PAGES = 1;
      const NEARBY_PRELOAD_RADIUS = 3;
      const SINGLE_PAGE_BREAKPOINT = 760;
      const HD_PRELOAD_RADIUS = 1;
      const HD_ZOOM_STEP = 0.25;
      const HD_ABSOLUTE_MAX_ZOOM = 4;
      const HD_DEVICE_PIXEL_RATIO_CAP = 2;
      // Use one moderate render density for every page. The previous visible-page
      // HiDPI promotion rendered the same page twice and could compete with the
      // first page-turn animation on Shopify.
      const PAGE_RENDER_DENSITY = 1.1;
      const MAX_PAGE_RENDER_PIXELS = 4_500_000;

      // PageFlip 2.0.7 normally makes the Canvas backing store equal to its CSS
      // size. That is only 1 physical pixel per CSS pixel, so the page texture can
      // look soft while it is rotated and clipped during a fold. Supersample only
      // the animation Canvas; the original Shopify images are reused as-is and no
      // second image set or PDF render pass is created.
      // const TURN_CANVAS_SUPERSAMPLE = 2;
      // const TURN_CANVAS_MAX_PIXELS = 8_500_000;

      const TURN_CANVAS_SUPERSAMPLE = 2;
      const TURN_CANVAS_MAX_PIXELS = 7_500_000;

      const renderJobs = new Map();
      const pageElements = new Map();
      const textLineJobs = new Map();
      const pageObjectUrls = new Set();

      function ensurePageFlipLibrary() {
        if (window.St?.PageFlip) return Promise.resolve(window.St.PageFlip);
        if (window.__aycPageFlipLibraryPromise) return window.__aycPageFlipLibraryPromise;

        window.__aycPageFlipLibraryPromise = new Promise((resolve, reject) => {
          const existing = document.querySelector('script[data-ayc-pageflip-library]');
          const script = existing || document.createElement('script');
          let finished = false;

          const succeed = () => {
            if (finished) return;
            if (!window.St?.PageFlip) {
              finished = true;
              reject(new Error('The page-turning library loaded, but PageFlip is unavailable.'));
              return;
            }
            finished = true;
            resolve(window.St.PageFlip);
          };

          const fail = () => {
            if (finished) return;
            finished = true;
            window.__aycPageFlipLibraryPromise = null;
            reject(new Error('The page-turning library could not be downloaded.'));
          };

          script.addEventListener('load', succeed, { once: true });
          script.addEventListener('error', fail, { once: true });

          if (!existing) {
            script.src = 'https://cdn.jsdelivr.net/npm/page-flip@2.0.7/dist/js/page-flip.browser.js';
            script.async = true;
            script.dataset.aycPageflipLibrary = 'true';
            document.head.appendChild(script);
          } else if (window.St?.PageFlip) {
            succeed();
          }
        });

        return window.__aycPageFlipLibraryPromise;
      }

      function waitForPageFlip(timeout = 15000) {
        return Promise.race([
          ensurePageFlipLibrary(),
          new Promise((_, reject) => {
            setTimeout(() => reject(new Error('The page-turning library timed out while loading.')), timeout);
          }),
        ]);
      }

      function formatBytes(bytes) {
        if (!Number.isFinite(bytes) || bytes <= 0) return '—';
        const units = ['B', 'KB', 'MB', 'GB'];
        const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
        const value = bytes / 1024 ** index;
        return `${value.toFixed(index >= 2 ? 1 : 0)} ${units[index]}`;
      }

      function normalizeUrl(value, label = 'URL', baseUrl = window.location.href) {
        const url = new URL(value, baseUrl);
        if (!/^https?:$/.test(url.protocol)) {
          throw new Error(`${label} must use an http or https address.`);
        }
        return url.href;
      }

      function normalizePageImageUrl(value, label = 'Page image URL', baseUrl = window.location.href) {
        const url = new URL(value, baseUrl);
        // http/https are used online; file is retained for direct image URLs;
        // blob supports an optional future folder picker.
        if (!['http:', 'https:', 'file:', 'blob:'].includes(url.protocol)) {
          throw new Error(`${label} must use http, https, file, or blob, or be a relative path.`);
        }
        return url.href;
      }

      function addNoStoreToken(url) {
        const parsed = new URL(url, window.location.href);
        parsed.searchParams.set('ayc_config', String(Date.now()));
        return parsed.href;
      }

      async function fetchJsonNoStore(url, label) {
        const response = await fetch(addNoStoreToken(url), {
          cache: 'no-store',
          credentials: 'same-origin',
        });
        if (!response.ok) {
          throw new Error(`${label} could not be loaded (${response.status}).`);
        }
        try {
          return await response.json();
        } catch (error) {
          throw new Error(`${label} is not valid JSON.`);
        }
      }

      function setCatalogTitle(lines) {
        if (!els.catalogTitle || !Array.isArray(lines) || !lines.length) return;
        els.catalogTitle.replaceChildren();
        lines.forEach((line, index) => {
          if (index) els.catalogTitle.append(document.createElement('br'));
          els.catalogTitle.append(document.createTextNode(String(line)));
        });
      }

      function applyCatalogMetadata(config) {
        if (config.issue && els.issueLabel) els.issueLabel.textContent = String(config.issue);
        if (config.titleLines) setCatalogTitle(config.titleLines);
        if (config.company && els.companyName) els.companyName.textContent = String(config.company);
        if (config.description && els.catalogDescription) {
          els.catalogDescription.textContent = String(config.description);
        }
        if (config.updated && els.updatedValue) els.updatedValue.textContent = String(config.updated);
        if (config.brands != null && els.brandsValue) {
          els.brandsValue.textContent = String(config.brands);
        }
        if (config.browserTitle) document.title = String(config.browserTitle);
        if (config.downloadFileName) {
          configuredDownloadFileName = String(config.downloadFileName);
          catalogFileName = configuredDownloadFileName;
        }
      }

      async function loadActiveCatalogConfiguration() {
        const inlineConfigElement = getById('ayc-ecat-shopify-config');
        if (!inlineConfigElement) {
          throw new Error('The Shopify catalog configuration is missing.');
        }

        let versionConfig;
        try {
          versionConfig = JSON.parse(inlineConfigElement.textContent || '{}');
        } catch (error) {
          throw new Error('The Shopify catalog configuration is not valid JSON.');
        }

        const pageCount = Math.max(0, Math.floor(Number(versionConfig.pageCount) || 0));
        const pagePadding = Math.max(0, Math.floor(Number(versionConfig.pagePadding) || 0));
        if (!pageCount) throw new Error('Page count must be greater than 0.');

        activeCatalogConfig = versionConfig;
        activeCatalogConfigUrl = window.location.href;
        PAGE_IMAGE_URLS = Array.isArray(versionConfig.pageImageUrls) ? versionConfig.pageImageUrls : [];
        PAGE_IMAGE_TEMPLATE = '';
        PAGE_IMAGE_COUNT = pageCount;
        PAGE_IMAGE_PADDING = pagePadding;

        HD_PAGE_IMAGE_URLS = Array.isArray(versionConfig.hdPageImageUrls) ? versionConfig.hdPageImageUrls : [];
        HD_PAGE_IMAGE_TEMPLATE = '';
        const configuredHdCount = Number(versionConfig.hdPageCount);
        HD_PAGE_IMAGE_COUNT = Number.isFinite(configuredHdCount)
          ? Math.max(0, Math.floor(configuredHdCount))
          : pageCount;
        const configuredHdPadding = Number(versionConfig.hdPagePadding);
        HD_PAGE_IMAGE_PADDING = Number.isFinite(configuredHdPadding)
          ? Math.max(0, Math.floor(configuredHdPadding))
          : pagePadding;

        const pdfReference = String(versionConfig.pdf || '').trim();
        PDF_URL = pdfReference ? normalizeUrl(pdfReference, 'pdf', window.location.href) : '';

        applyCatalogMetadata(versionConfig);
        return versionConfig;
      }

      function buildImageUrlList({ explicitUrls, template, count, padding, label, baseUrl = window.location.href }) {
        const explicit = Array.isArray(explicitUrls)
          ? explicitUrls.map((value) => String(value || '').trim()).filter(Boolean)
          : [];
        if (explicit.length) {
          return explicit.map((value, index) => normalizePageImageUrl(value, `${label}[${index}]`, baseUrl));
        }

        const cleanTemplate = String(template || '').trim();
        const cleanCount = Math.max(0, Math.floor(Number(count) || 0));
        if (!cleanTemplate || !cleanCount) return [];
        if (!cleanTemplate.includes('{page}')) {
          throw new Error(`${label} template must contain the {page} placeholder.`);
        }

        const cleanPadding = Math.max(0, Math.floor(Number(padding) || 0));
        return Array.from({ length: cleanCount }, (_, index) => {
          const pageNumber = String(index + 1).padStart(cleanPadding, '0');
          return normalizePageImageUrl(cleanTemplate.replaceAll('{page}', pageNumber), `${label} template`, baseUrl);
        });
      }

      function buildConfiguredPageImageUrls() {
        return buildImageUrlList({
          explicitUrls: PAGE_IMAGE_URLS,
          template: PAGE_IMAGE_TEMPLATE,
          count: PAGE_IMAGE_COUNT,
          padding: PAGE_IMAGE_PADDING,
          label: 'PAGE_IMAGE_URLS',
          baseUrl: activeCatalogConfigUrl || window.location.href,
        });
      }

      function buildConfiguredHdPageImageUrls() {
        return buildImageUrlList({
          explicitUrls: HD_PAGE_IMAGE_URLS,
          template: HD_PAGE_IMAGE_TEMPLATE,
          count: HD_PAGE_IMAGE_COUNT,
          padding: HD_PAGE_IMAGE_PADDING,
          label: 'HD_PAGE_IMAGE_URLS',
          baseUrl: activeCatalogConfigUrl || window.location.href,
        });
      }

      function showToast(message) {
        clearTimeout(toastTimer);
        els.toast.textContent = message;
        els.toast.classList.add('ayc-ecat-show');
        toastTimer = setTimeout(() => els.toast.classList.remove('ayc-ecat-show'), 2200);
      }

      function setError(message) {
        els.viewerState.classList.add('ayc-ecat-is-error');
        els.viewerState.querySelector('.ayc-ecat-state-icon').textContent = '!';
        els.stateTitle.textContent = 'Catalog unavailable';
        els.stateMessage.textContent = message;
        els.root.classList.remove('ayc-ecat-viewer-ready');
      }

      function updateRangeProgress(value = currentPage) {
        const max = Math.max(1, totalPages);
        const progress = max <= 1 ? 0 : ((value - 1) / (max - 1)) * 100;
        els.pageRange.style.setProperty('--range-progress', `${progress}%`);
      }

      function isViewerFullscreen() {
        return (
          document.fullscreenElement === els.viewerSection ||
          document.webkitFullscreenElement === els.viewerSection ||
          els.viewerSection?.matches?.(':fullscreen') ||
          false
        );
      }

      function calculateBookFrame() {
        const stageRect = els.bookStage.getBoundingClientRect();
        const sectionRect = els.viewerSection?.getBoundingClientRect?.() || stageRect;
        const measuredStageWidth = Math.floor(stageRect.width || els.bookStage.clientWidth || 0);
        const measuredStageHeight = Math.floor(stageRect.height || els.bookStage.clientHeight || 0);
        const sectionWidth = Math.floor(sectionRect.width || measuredStageWidth || 0);
        const fullscreen = isViewerFullscreen();

        // Orientation follows the actual Shopify section width, not the browser
        // viewport. This also lets an embedded narrow column become single-page
        // while the surrounding desktop window remains wide.
        const orientationWidth = Math.max(
          1,
          Math.min(measuredStageWidth || sectionWidth, sectionWidth || measuredStageWidth)
        );
        const portrait = orientationWidth < SINGLE_PAGE_BREAKPOINT;

        if (portrait) {
          // In single-page mode the catalog page itself spans the complete section.
          // Do not constrain it by the old fixed stage height; the stage grows to
          // the page aspect ratio and keeps transparent vertical turn overscan.
          const width = Math.max(1, sectionWidth || measuredStageWidth);
          return {
            width: Math.floor(width),
            height: Math.max(1, Math.floor(width / pageRatio)),
            portrait: true,
            fullscreen,
          };
        }

        const availableWidth = Math.max(1, measuredStageWidth);
        const availableHeight = Math.max(1, measuredStageHeight || Math.round(availableWidth / (pageRatio * 2)));
        const maxPageWidth = fullscreen ? Number.POSITIVE_INFINITY : 650;

        // The Canvas host contains roughly 15% transparent vertical overscan.
        // Account for it in fullscreen so the largest possible spread, including
        // its page-turn area, fits inside the available viewport height.
        const verticalFitFactor = fullscreen ? 1.15 : 1;
        const spreadWidth = Math.max(
          1,
          Math.min(maxPageWidth * 2, availableWidth, (availableHeight / verticalFitFactor) * pageRatio * 2)
        );
        return {
          width: Math.floor(spreadWidth),
          height: Math.max(1, Math.floor(spreadWidth / (pageRatio * 2))),
          portrait: false,
          fullscreen,
        };
      }

      function applyBookFrameSize({ force = false } = {}) {
        const next = calculateBookFrame();
        // CanvasRender can draw the folding sheet outside the static page area
        // only when the canvas itself has spare transparent pixels. Keep the
        // visible spread at `next.height`, and add a responsive overscan band.
        const overscan = Math.round(Math.min(76, Math.max(34, next.height * 0.075)));
        const hostHeight = next.height + overscan * 2;
        const changed =
          force || Math.abs(next.width - bookFrameWidth) > 1 || Math.abs(hostHeight - bookFrameHeight) > 1;

        if (!changed) return false;

        bookFrameWidth = next.width;
        bookFrameHeight = hostHeight;
        els.root.style.setProperty('--ayc-ecat-active-overscan', `${overscan}px`);
        els.book.style.setProperty('width', `${bookFrameWidth}px`, 'important');
        els.book.style.setProperty('height', `${bookFrameHeight}px`, 'important');
        els.book.style.setProperty('min-width', '0', 'important');
        els.book.style.setProperty('min-height', '0', 'important');
        els.book.style.setProperty('max-width', '100%', 'important');
        els.book.style.setProperty('max-height', 'none', 'important');
        els.book.dataset.layout = next.portrait ? 'portrait' : 'landscape';
        els.root.classList.toggle('ayc-ecat-single-page', next.portrait);
        els.root.classList.toggle('ayc-ecat-is-fullscreen', Boolean(next.fullscreen));
        if (next.portrait) {
          els.root.style.setProperty('--ayc-ecat-portrait-stage-height', `${hostHeight}px`);
        } else {
          els.root.style.removeProperty('--ayc-ecat-portrait-stage-height');
        }
        els.book.dataset.pageHeight = String(next.height);
        els.book.dataset.overscan = String(overscan);
        sizeOriginalReaderSpread();
        return true;
      }

      function wantsPortraitMode() {
        return els.book.dataset.layout === 'portrait';
      }

      function applyResponsivePageFlipSettings() {
        if (!pageFlip) return false;
        const settings = pageFlip.getRender?.()?.getSettings?.();
        if (!settings) return false;

        const portrait = wantsPortraitMode();
        // StPageFlip chooses portrait mode when the container cannot fit two
        // pages at minWidth. On a narrow Shopify section, make the minimum page
        // width larger than half of the available book width. On wide layouts,
        // restore the small minimum so a two-page spread is allowed.
        const nextMinWidth = portrait ? Math.max(100, Math.ceil(bookFrameWidth * 0.62)) : 100;
        const nextMinHeight = Math.max(140, Math.round(nextMinWidth / pageRatio));
        const changed =
          Math.abs((settings.minWidth || 0) - nextMinWidth) > 1 ||
          Math.abs((settings.minHeight || 0) - nextMinHeight) > 1;

        settings.minWidth = nextMinWidth;
        settings.minHeight = nextMinHeight;
        settings.maxWidth = 4096;
        settings.maxHeight = 4096;
        settings.usePortrait = true;
        return changed;
      }

      function scheduleBookLayoutSync(delay = 70) {
        clearTimeout(layoutSyncTimer);
        layoutSyncTimer = setTimeout(() => {
          syncBookLayout().catch(console.error);
        }, delay);
      }

      async function syncBookLayout() {
        if ((!directImageMode && !pdfDocument) || layoutSyncRunning) return;
        if (!pageFlip) {
          applyBookFrameSize();
          return;
        }

        if (pageFlip.getState?.() !== 'read') {
          layoutSyncPending = true;
          return;
        }

        layoutSyncRunning = true;
        layoutSyncPending = false;
        els.root.classList.add('ayc-ecat-layout-syncing');

        try {
          const currentIndex = pageFlip.getCurrentPageIndex?.() || 0;
          // A responsive orientation change can reveal the neighboring page that
          // was not visible in portrait mode. Prepare the complete local spread
          // before PageFlip recalculates its geometry, otherwise a lazy blank URL
          // can appear on the newly exposed half of the book.
          await ensurePagesTurnReady(getPagesAround(currentIndex + 1, 2), 'standard');
          const beforeOrientation = pageFlip.getOrientation?.();
          const changed = applyBookFrameSize();
          const settingsChanged = applyResponsivePageFlipSettings();

          /*
          StPageFlip has two resize layers. CanvasUI resizes the actual canvas,
          while PageFlip.update() recalculates the book rectangle/orientation.
          The responsive minWidth above also forces portrait mode whenever the
          actual Shopify section is narrower than SINGLE_PAGE_BREAKPOINT.
        */
          pageFlip.getUI?.()?.update?.();
          pageFlip.update?.();
          configureCanvasRenderSurface();
          pageFlip.turnToPage?.(currentIndex);

          await waitForBrowserPaint();

          // A second pass handles animated Shopify widths and orientation changes.
          const afterOrientation = pageFlip.getOrientation?.();
          const expectedOrientation = wantsPortraitMode() ? 'portrait' : 'landscape';
          if (
            changed ||
            settingsChanged ||
            beforeOrientation !== afterOrientation ||
            afterOrientation !== expectedOrientation
          ) {
            applyResponsivePageFlipSettings();
            pageFlip.getUI?.()?.update?.();
            pageFlip.update?.();
            configureCanvasRenderSurface();
            pageFlip.turnToPage?.(currentIndex);
            await waitForBrowserPaint();
          }

          updateNavigation(currentIndex);
        } finally {
          layoutSyncRunning = false;
          requestAnimationFrame(() => els.root.classList.remove('ayc-ecat-layout-syncing'));
        }
      }

      function settleBookAfterTurn() {
        if (!pageFlip || settleFrameQueued) return;
        settleFrameQueued = true;

        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            settleFrameQueued = false;
            if (!pageFlip) return;

            const changed = applyBookFrameSize();
            layoutSyncPending = false;

            pageFlip.getRender?.().clearShadow?.();
            if (changed) {
              pageFlip.getUI?.()?.update?.();
              pageFlip.update?.();
              configureCanvasRenderSurface();
            } else {
              pageFlip.getPageCollection?.()?.show?.(pageFlip.getCurrentPageIndex());
            }
            updateNavigation(pageFlip.getCurrentPageIndex());
          })
        );
      }

      function updateNavigation(pageIndex = 0) {
        currentPage = Math.min(totalPages, Math.max(1, Number(pageIndex) + 1));
        const isLandscape = pageFlip?.getOrientation?.() === 'landscape';
        const lastVisible = isLandscape ? Math.min(totalPages, currentPage + 1) : currentPage;
        els.pageStatus.textContent =
          lastVisible > currentPage
            ? `${currentPage}–${lastVisible} / ${totalPages}`
            : `${currentPage} / ${totalPages}`;
        els.pageRange.value = String(currentPage);
        updateRangeProgress(currentPage);
        els.prevButton.disabled = currentPage <= 1;
        els.nextButton.disabled = currentPage >= totalPages;
        lastPrimeKey = '';

        if (pageFlip) {
          renderNearby(currentPage);
          primeTurn(1);
          primeTurn(-1);
          if (pageFlip.getState?.() === 'read') {
            syncOriginalReaderSpread(pageIndex).catch((error) => {
              console.warn('The original reader image layer could not be updated', error);
            });
          } else {
            hideOriginalReaderSpread();
          }
        }
      }

      function makePageElement(pageNumber) {
        const page = document.createElement('div');
        page.className = 'ayc-ecat-catalog-page';
        // Do not use data-page on the flipbook pages. That attribute is reserved
        // for Contents/navigation buttons; sharing it here makes a cover click
        // trigger the catalog jump handler and scroll the browser unexpectedly.
        page.dataset.pdfPage = String(pageNumber);

        /*
        StPageFlip creates temporary page copies with cloneNode(true) while a
        soft sheet is turning. A cloned <canvas> keeps its dimensions but not
        its drawing bitmap, which is why Shopify could show the old page below
        the fold until the animation ended. An <img> keeps its src when cloned,
        so both sides of the sheet always contain the correct catalog page.
      */
        const image = document.createElement('img');
        image.className = 'ayc-ecat-page-image';
        image.alt = `Catalog page ${pageNumber}`;
        image.decoding = 'async';
        image.loading = 'eager';
        image.draggable = false;

        const loader = document.createElement('div');
        loader.className = 'ayc-ecat-page-loader';
        loader.textContent = `Page ${pageNumber}`;

        page.append(image, loader);
        pageElements.set(pageNumber, {
          pageNumber,
          page,
          image,
          renderLevel: 0,
          currentUrl: '',
          pendingUrl: '',
          pendingLevel: 0,
          // URL currently guaranteed to exist inside StPageFlip's ImagePage
          // collection. A rendered PDF image is not considered turn-ready until
          // this matches currentUrl; this prevents a lazy blank placeholder from
          // appearing on either side of a spread.
          collectionUrl: '',
        });
        return page;
      }

      function getEffectiveRenderLevel(record) {
        return Math.max(record?.renderLevel || 0, record?.pendingLevel || 0);
      }

      function createBlankPageUrl() {
        if (sharedBlankPageUrl) return sharedBlankPageUrl;
        const width = Math.max(24, Math.round(renderWidth / 12));
        const height = Math.max(32, Math.round(renderHeight / 12));
        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
          <rect width="100%" height="100%" fill="#fff"/>
        </svg>`;
        sharedBlankPageUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
        return sharedBlankPageUrl;
      }

      function initializePageImageUrls() {
        // StPageFlip requires a URL for every page at initialization. Use one
        // silent blank fallback instead of a visible "Loading page" sheet. The
        // pointer gate below prevents an unloaded fallback from ever being turned
        // into view; the real target page is rendered first.
        const blank = createBlankPageUrl();
        pageImageUrls = Array.from({ length: totalPages }, () => blank);
      }

      function canvasToBlob(canvas, type, quality) {
        return new Promise((resolve, reject) => {
          canvas.toBlob(
            (blob) => {
              if (blob) resolve(blob);
              else reject(new Error('The browser could not create a catalog page image.'));
            },
            type,
            quality
          );
        });
      }

      async function createPageObjectUrl(canvas, requestedLevel) {
        let blob;
        try {
          blob = await canvasToBlob(canvas, 'image/webp', requestedLevel === 1 ? 0.84 : 1);
        } catch (error) {
          blob = await canvasToBlob(canvas, 'image/png');
        }
        const url = URL.createObjectURL(blob);
        pageObjectUrls.add(url);
        return url;
      }

      function decodeImageUrl(url) {
        return new Promise((resolve, reject) => {
          const probe = new Image();
          probe.decoding = 'async';
          probe.onload = () => resolve();
          probe.onerror = () => reject(new Error('A catalog page preview could not be decoded.'));
          probe.src = url;
          if (typeof probe.decode === 'function') {
            probe
              .decode()
              .then(resolve)
              .catch(() => {
                // Some browsers reject decode() even though onload still succeeds.
              });
          }
        });
      }

      async function applyRenderedUrl(record, url, requestedLevel) {
        if (!record || !url || record.renderLevel >= requestedLevel) return;
        await decodeImageUrl(url);
        if (record.renderLevel >= requestedLevel) return;

        record.image.src = url;
        record.currentUrl = url;
        record.renderLevel = requestedLevel;
        record.page.classList.add('ayc-ecat-rendered');

        if (record.pageNumber && pageImageUrls.length === totalPages) {
          pageImageUrls[record.pageNumber - 1] = url;
          if (pageFlip) {
            if (pageFlip.getState?.() === 'read') {
              // In-place patching is useful for background loading, but some
              // Shopify/browser combinations keep the old placeholder texture in
              // CanvasRender until the image collection is rebuilt. Therefore a
              // page is only marked collection-ready after a verified patch or a
              // snapshot-masked collection refresh.
              await patchCanvasPageImage(record.pageNumber, url);
            } else {
              pendingCanvasPatches.set(record.pageNumber, url);
            }
          }
        }

        if (record.pendingLevel <= requestedLevel) {
          record.pendingUrl = '';
          record.pendingLevel = 0;
        }
      }

      /*
      Completed page images are staged only when needed by the canvas reader.
      This version no longer performs a second high-resolution render pass.
    */
      async function flushPendingRenders(pageNumbers = null) {
        const records = pageNumbers
          ? pageNumbers.map((pageNumber) => pageElements.get(pageNumber)).filter(Boolean)
          : [...pageElements.values()];
        const jobs = [];

        for (const record of records) {
          if (!record.pendingUrl || record.pendingLevel <= record.renderLevel) {
            record.pendingUrl = '';
            record.pendingLevel = 0;
            continue;
          }
          const url = record.pendingUrl;
          const level = record.pendingLevel;
          record.pendingUrl = '';
          record.pendingLevel = 0;
          jobs.push(applyRenderedUrl(record, url, level));
        }

        await Promise.all(jobs);
      }

      function waitForBrowserPaint() {
        return new Promise((resolve) => {
          requestAnimationFrame(() => requestAnimationFrame(resolve));
        });
      }

      function getTurnCanvasPixelRatio(cssWidth, cssHeight) {
        const area = Math.max(1, cssWidth * cssHeight);
        const pixelBudgetRatio = Math.sqrt(TURN_CANVAS_MAX_PIXELS / area);
        return Math.max(1, Math.min(TURN_CANVAS_SUPERSAMPLE, pixelBudgetRatio));
      }

      function resizeTurnCanvasBackingStore() {
        if (!pageFlip) return 1;
        const canvas = els.book.querySelector('canvas:not(.ayc-ecat-canvas-snapshot)');
        const context = pageFlip.getRender?.()?.getContext?.() || canvas?.getContext?.('2d');
        if (!canvas || !context) return 1;

        const rect = canvas.getBoundingClientRect();
        const computed = getComputedStyle(canvas);
        const cssWidth = Math.max(1, Math.round(rect.width || parseFloat(computed.width) || canvas.clientWidth || 1));
        const cssHeight = Math.max(
          1,
          Math.round(rect.height || parseFloat(computed.height) || canvas.clientHeight || 1)
        );
        const ratio = getTurnCanvasPixelRatio(cssWidth, cssHeight);
        const targetWidth = Math.max(1, Math.round(cssWidth * ratio));
        const targetHeight = Math.max(1, Math.round(cssHeight * ratio));

        if (canvas.width !== targetWidth || canvas.height !== targetHeight) {
          canvas.width = targetWidth;
          canvas.height = targetHeight;
        }

        canvas.dataset.aycEcatPixelRatio = String(ratio);
        canvas.dataset.aycEcatCssWidth = String(cssWidth);
        canvas.dataset.aycEcatCssHeight = String(cssHeight);
        context.setTransform(ratio, 0, 0, ratio, 0, 0);
        context.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in context) context.imageSmoothingQuality = 'high';
        return ratio;
      }

      function installTurnCanvasResizeHook() {
        const ui = pageFlip?.getUI?.();
        if (!ui || ui.__aycEcatHiDpiUpdateInstalled || typeof ui.update !== 'function') return;

        const originalUpdate = ui.update.bind(ui);
        ui.update = (...args) => {
          const result = originalUpdate(...args);
          resizeTurnCanvasBackingStore();
          return result;
        };
        ui.__aycEcatHiDpiUpdateInstalled = true;
      }

      function configureCanvasRenderSurface() {
        if (!pageFlip) return;
        const render = pageFlip.getRender?.();
        const canvas = els.book.querySelector('canvas:not(.ayc-ecat-canvas-snapshot)');
        const context = render?.getContext?.() || canvas?.getContext?.('2d');
        if (!canvas || !context) return;

        installTurnCanvasResizeHook();
        resizeTurnCanvasBackingStore();

        // CanvasRender normally paints its complete canvas white every frame.
        // Replace that internal clear method so only the catalog pages are opaque;
        // the overscan band remains transparent and reveals the beige viewer.
        // Clear in physical-pixel coordinates, then restore the supersampled CSS
        // coordinate system before CanvasRender draws the next frame.
        if (render && typeof render.clear === 'function' && !render.__aycEcatTransparentClear) {
          render.clear = () => {
            const ratio = Math.max(1, Number(canvas.dataset.aycEcatPixelRatio) || 1);
            context.save();
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.clearRect(0, 0, canvas.width, canvas.height);
            context.restore();
            context.setTransform(ratio, 0, 0, ratio, 0, 0);
            context.imageSmoothingEnabled = true;
            if ('imageSmoothingQuality' in context) context.imageSmoothingQuality = 'high';
          };
          render.__aycEcatTransparentClear = true;
        }
      }

      function createCanvasSnapshot() {
        const source = els.book.querySelector('canvas:not(.ayc-ecat-canvas-snapshot)');
        if (!source || !source.width || !source.height) return null;
        const snapshot = document.createElement('canvas');
        snapshot.className = 'ayc-ecat-canvas-snapshot';
        snapshot.width = source.width;
        snapshot.height = source.height;
        const context = snapshot.getContext('2d', { alpha: true });
        context?.drawImage(source, 0, 0);
        els.book.append(snapshot);
        return snapshot;
      }

      function removeCanvasSnapshot(snapshot) {
        if (!snapshot?.isConnected) return;
        snapshot.classList.add('ayc-ecat-fade-out');
        setTimeout(() => snapshot.remove(), 140);
      }

      function createDecodedImage(url) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          let settled = false;

          const finish = () => {
            if (settled) return;
            if (!image.naturalWidth || !image.naturalHeight) {
              fail();
              return;
            }
            settled = true;
            image.onload = null;
            image.onerror = null;
            resolve(image);
          };

          const fail = () => {
            if (settled) return;
            settled = true;
            image.onload = null;
            image.onerror = null;
            reject(new Error(`A catalog page image could not be loaded: ${url}`));
          };

          image.decoding = 'async';
          image.onload = finish;
          image.onerror = fail;
          image.src = url;

          if (image.complete) {
            queueMicrotask(() => (image.naturalWidth ? finish() : fail()));
            return;
          }

          if (typeof image.decode === 'function') {
            image
              .decode()
              .then(finish)
              .catch(() => {
                // Some browsers reject decode() before firing load/error. Keep the
                // event handlers active, but fail immediately once the request has
                // completed without decodable pixels (important for HD fallback).
                if (image.complete && !image.naturalWidth) fail();
              });
          }
        });
      }

      /*
      updateFromImages() destroys and recreates the complete ImagePageCollection.
      That briefly clears the canvas whenever one lazy page finishes. Instead,
      replace the decoded image inside the existing ImagePage object. TypeScript
      private fields compile to ordinary object properties in page-flip 2.0.7,
      so this remains local to the reader and avoids a collection rebuild.
    */
      async function patchCanvasPageImage(pageNumber, url) {
        if (!pageFlip || pageNumber < 1 || pageNumber > totalPages) return false;
        const page = pageFlip.getPage?.(pageNumber - 1);
        if (!page) return false;

        const image = await createDecodedImage(url);
        const keys = Reflect.ownKeys(page);
        let imagePatched = false;
        let hrefPatched = false;

        for (const key of keys) {
          const value = page[key];
          const keyName = String(key).toLowerCase();
          if (value instanceof HTMLImageElement || keyName === 'image') {
            try {
              page[key] = image;
              imagePatched = true;
            } catch (error) {}
          } else if (
            typeof value === 'string' &&
            (keyName.includes('href') || keyName.includes('src') || keyName.includes('url'))
          ) {
            try {
              page[key] = url;
              hrefPatched = true;
            } catch (error) {}
          } else if (typeof value === 'boolean' && keyName.includes('load')) {
            try {
              page[key] = true;
            } catch (error) {}
          }
        }

        // Known property names in StPageFlip's ImagePage implementation.
        if (!imagePatched) {
          try {
            page.image = image;
            imagePatched = page.image === image;
          } catch (error) {}
        }
        try {
          page.href = url;
          hrefPatched = true;
        } catch (error) {}
        try {
          page.isLoad = true;
        } catch (error) {}

        if (!imagePatched && hrefPatched && typeof page.load === 'function') {
          try {
            page.load();
            imagePatched = true;
          } catch (error) {}
        }

        if (!imagePatched) {
          fallbackRefreshNeeded = true;
          return false;
        }

        const currentIndex = pageFlip.getCurrentPageIndex?.() || 0;
        const visiblePages = getPagesAround(currentIndex + 1, 1);
        if (visiblePages.includes(pageNumber) && pageFlip.getState?.() === 'read') {
          pageFlip.getPageCollection?.()?.show?.(currentIndex);
        }
        return true;
      }

      async function flushPendingCanvasPatches() {
        if (!pageFlip || pageFlip.getState?.() !== 'read') return;
        const patches = [...pendingCanvasPatches.entries()];
        pendingCanvasPatches.clear();
        for (const [pageNumber, url] of patches) {
          try {
            await patchCanvasPageImage(pageNumber, url);
          } catch (error) {
            console.error(`Page ${pageNumber} could not be patched in place`, error);
            fallbackRefreshNeeded = true;
          }
        }
        if (fallbackRefreshNeeded) await refreshCanvasPagesWithoutFlash();
      }

      async function refreshCanvasPagesWithoutFlash() {
        if (!pageFlip || fallbackRefreshRunning || pageFlip.getState?.() !== 'read') return;
        fallbackRefreshRunning = true;
        fallbackRefreshNeeded = false;
        const snapshot = createCanvasSnapshot();
        const currentIndex = pageFlip.getCurrentPageIndex?.() || 0;
        try {
          // Every replacement URL was decoded before this point. The snapshot
          // masks the collection rebuild until the new canvas has painted twice.
          pageFlip.updateFromImages(pageImageUrls.slice());
          configureCanvasRenderSurface();
          pageFlip.getUI?.()?.update?.();
          pageFlip.turnToPage?.(currentIndex);
          await waitForBrowserPaint();
          await waitForBrowserPaint();
          // updateFromImages() recreates the complete ImagePage collection from
          // pageImageUrls. Every rendered record is now guaranteed to be backed
          // by its real catalog page rather than the silent blank bootstrap image.
          for (const record of pageElements.values()) {
            if (record.currentUrl && pageImageUrls[record.pageNumber - 1] === record.currentUrl) {
              record.collectionUrl = record.currentUrl;
            }
          }
          updateNavigation(currentIndex);
        } finally {
          removeCanvasSnapshot(snapshot);
          fallbackRefreshRunning = false;
        }
      }

      /*
      PDF.js still renders into an off-screen canvas, but the finished page is
      converted to an image URL before it enters StPageFlip. HTML page copies
      therefore clone a real image source instead of an empty canvas bitmap.
    */
      function renderPage(pageNumber, _quality = 'standard') {
        if (pageNumber < 1 || pageNumber > totalPages) return Promise.resolve();
        if (!directImageMode && !pdfDocument) return Promise.resolve();

        const record = pageElements.get(pageNumber);
        if (!record) return Promise.resolve();

        const requestedLevel = 1;
        if (getEffectiveRenderLevel(record) >= requestedLevel) return Promise.resolve();

        if (renderJobs.has(pageNumber)) {
          return renderJobs.get(pageNumber).then(() => {
            if (getEffectiveRenderLevel(record) >= requestedLevel) return;
            return renderPage(pageNumber, _quality);
          });
        }

        const job = (async () => {
          if (directImageMode) {
            const imageUrl = directPageImageUrls[pageNumber - 1];
            if (!imageUrl) throw new Error(`No image URL is configured for page ${pageNumber}.`);
            await decodeImageUrl(imageUrl);
            if (getEffectiveRenderLevel(record) < requestedLevel) {
              await applyRenderedUrl(record, imageUrl, requestedLevel);
            }
            return;
          }

          const pdfPage = await pdfDocument.getPage(pageNumber);
          try {
            const baseViewport = pdfPage.getViewport({ scale: 1 });
            let scale = Math.min(
              (renderWidth * PAGE_RENDER_DENSITY) / baseViewport.width,
              (renderHeight * PAGE_RENDER_DENSITY) / baseViewport.height
            );

            const estimatedPixels = baseViewport.width * baseViewport.height * scale * scale;
            if (estimatedPixels > MAX_PAGE_RENDER_PIXELS) {
              scale *= Math.sqrt(MAX_PAGE_RENDER_PIXELS / estimatedPixels);
            }
            const viewport = pdfPage.getViewport({ scale });

            const buffer = document.createElement('canvas');
            buffer.width = Math.max(1, Math.ceil(viewport.width));
            buffer.height = Math.max(1, Math.ceil(viewport.height));

            const bufferContext = buffer.getContext('2d', {
              alpha: false,
              desynchronized: true,
            });
            bufferContext.imageSmoothingEnabled = true;
            if ('imageSmoothingQuality' in bufferContext) {
              bufferContext.imageSmoothingQuality = 'high';
            }
            bufferContext.fillStyle = '#ffffff';
            bufferContext.fillRect(0, 0, buffer.width, buffer.height);

            await pdfPage.render({
              canvasContext: bufferContext,
              viewport,
              background: '#ffffff',
            }).promise;

            const imageUrl = await createPageObjectUrl(buffer, requestedLevel);
            if (getEffectiveRenderLevel(record) < requestedLevel) {
              await applyRenderedUrl(record, imageUrl, requestedLevel);
            }
          } finally {
            pdfPage.cleanup();
          }
        })().finally(() => {
          if (renderJobs.get(pageNumber) === job) renderJobs.delete(pageNumber);
        });

        renderJobs.set(pageNumber, job);
        return job;
      }

      async function preloadInitialPages() {
        if (!totalPages) return;

        const initialCount = Math.min(totalPages, INITIAL_PRELOAD_PAGES);
        els.stateTitle.textContent = 'Preparing catalog';
        els.stateMessage.textContent = `Preparing the first pages… 0 / ${initialCount}`;

        let cursor = 1;
        let completed = 0;
        const workerCount = Math.min(3, initialCount);

        const worker = async () => {
          while (true) {
            const pageNumber = cursor++;
            if (pageNumber > initialCount) return;
            try {
              await renderPage(pageNumber, 'standard');
            } catch (error) {
              const expected = pageNumber === 1 ? activeCatalogConfig?.expectedFirstFilename : '';
              const suffix = expected ? ` Expected file: ${expected}` : '';
              throw new Error(`Catalog page ${pageNumber} could not be loaded.${suffix}`);
            }
            completed += 1;
            els.stateMessage.textContent = `Preparing the first pages… ${completed} / ${initialCount}`;
          }
        };

        await Promise.all(Array.from({ length: workerCount }, worker));
        backgroundPreloadCursor = initialCount + 1;
      }

      function requestIdle(callback, timeout = 900) {
        if ('requestIdleCallback' in window) {
          return window.requestIdleCallback(callback, { timeout });
        }
        return window.setTimeout(() => callback({ didTimeout: true, timeRemaining: () => 0 }), 32);
      }

      function getPagesAround(pageNumber, radius = NEARBY_PRELOAD_RADIUS) {
        const center = Math.min(totalPages, Math.max(1, Number(pageNumber) || 1));
        const pages = [];
        for (let page = center - radius; page <= center + radius + 1; page += 1) {
          if (page >= 1 && page <= totalPages) pages.push(page);
        }
        return [...new Set(pages)];
      }

      async function ensurePagesLoaded(pageNumbers, quality = 'standard', { refresh = true } = {}) {
        const requestedLevel = 1;
        const pages = [...new Set(pageNumbers)].filter((page) => page >= 1 && page <= totalPages);
        const missingPages = pages.filter((page) => {
          const record = pageElements.get(page);
          return record && getEffectiveRenderLevel(record) < requestedLevel;
        });
        if (!missingPages.length) return false;

        await Promise.all(missingPages.map((page) => renderPage(page, quality)));
        if (refresh && pageFlip && pageFlip.getState?.() === 'read') {
          await flushPendingCanvasPatches();
        }
        return true;
      }

      function arePagesCollectionReady(pageNumbers) {
        return pageNumbers.every((pageNumber) => {
          const record = pageElements.get(pageNumber);
          return (
            !record ||
            (record.renderLevel >= 1 && Boolean(record.currentUrl) && record.collectionUrl === record.currentUrl)
          );
        });
      }

      async function ensurePagesTurnReady(pageNumbers, quality = 'standard') {
        const pages = [...new Set(pageNumbers)].filter((page) => page >= 1 && page <= totalPages);
        if (!pages.length) return;

        await ensurePagesLoaded(pages, quality, { refresh: true });
        await flushPendingCanvasPatches();

        // A direct ImagePage field patch is fast, but it is not reliable in every
        // Shopify browser/compositor. Before any page can become visible, rebuild
        // the collection behind a canvas snapshot when one of the required pages
        // is not confirmed in the collection. The current spread stays visible,
        // and the destination spread is guaranteed to contain real catalog pages.
        if (!arePagesCollectionReady(pages)) {
          fallbackRefreshNeeded = true;
          await refreshCanvasPagesWithoutFlash();
        }

        if (!arePagesCollectionReady(pages)) {
          throw new Error('The destination catalog spread could not be prepared.');
        }
      }

      function startBackgroundPreload() {
        if (backgroundPreloadStarted || !totalPages) return;
        backgroundPreloadStarted = true;
        backgroundPreloadQueue = [];

        for (let page = backgroundPreloadCursor; page <= totalPages; page += 1) {
          const record = pageElements.get(page);
          if (!record || record.renderLevel < 1) backgroundPreloadQueue.push(page);
        }

        const preloadNext = (deadline) => {
          if (!backgroundPreloadQueue.length) return;

          // Never render a background page while the user is dragging or while a
          // turn animation is active. This keeps the first interactions smooth.
          if (turnLock || (pageFlip && pageFlip.getState?.() !== 'read')) {
            requestIdle(preloadNext, 700);
            return;
          }

          // Render one page per idle callback. Each finished image is patched into
          // its existing ImagePage object, so the visible canvas is never reset.
          const pageNumber = backgroundPreloadQueue.shift();
          renderPage(pageNumber, 'standard')
            .catch((error) => console.error(`Background preview failed for page ${pageNumber}`, error))
            .finally(() => requestIdle(preloadNext, 1200));
        };

        requestIdle(preloadNext, 1200);
      }

      function renderNearby(pageNumber = currentPage) {
        const nearby = getPagesAround(pageNumber, NEARBY_PRELOAD_RADIUS);
        ensurePagesLoaded(nearby, 'standard', { refresh: true }).catch(console.error);
      }

      function getTurnPages(direction = 1) {
        const pageIndex = pageFlip?.getCurrentPageIndex?.() ?? Math.max(0, currentPage - 1);
        const activePage = pageIndex + 1;
        const pages = [];
        if (direction > 0) {
          for (let page = activePage + 1; page <= activePage + 4; page += 1) pages.push(page);
        } else {
          for (let page = activePage - 1; page >= activePage - 4; page -= 1) pages.push(page);
        }
        return pages.filter((page) => page >= 1 && page <= totalPages);
      }

      function primeTurn(direction = 1, { wait = false } = {}) {
        if (!pageFlip) return wait ? Promise.resolve() : undefined;
        const key = `${pageFlip.getCurrentPageIndex()}:${direction}`;
        if (!wait && key === lastPrimeKey) return;
        lastPrimeKey = key;

        const task = ensurePagesLoaded(getTurnPages(direction), 'standard', { refresh: true });
        if (wait) return task;
        task.catch(console.error);
      }

      function arePagesRendered(pageNumbers) {
        return arePagesCollectionReady(pageNumbers);
      }

      function getEssentialTurnPages(direction = 1) {
        // CanvasRender may sample the turning sheet, its reverse side and both
        // pages in the destination spread. Prepare a wider safety window so no
        // blank bootstrap image can become visible during the fold.
        const count = pageFlip?.getOrientation?.() === 'portrait' ? 3 : 5;
        return getTurnPages(direction).slice(0, count);
      }

      async function prepareAndFlip(direction = 1) {
        if (!pageFlip || gestureLoadPromise) return gestureLoadPromise;
        const pages = getEssentialTurnPages(direction);
        if (arePagesRendered(pages)) return false;

        turnLock = true;
        gestureLoadPromise = (async () => {
          try {
            await ensurePagesTurnReady(pages, 'standard');
            await waitForBrowserPaint();
            hideOriginalReaderSpread();
            if (direction > 0) pageFlip.flipNext();
            else pageFlip.flipPrev();
            return true;
          } finally {
            gestureLoadPromise = null;
            turnUnlockTimer = setTimeout(() => {
              turnLock = false;
            }, 900);
          }
        })();
        return gestureLoadPromise;
      }

      async function flipSafely(direction = 1) {
        if (!pageFlip || turnLock) return;
        const pageIndex = pageFlip.getCurrentPageIndex();
        const activePage = pageIndex + 1;
        if (direction < 0 && activePage <= 1) return;
        if (direction > 0 && activePage >= totalPages) return;

        turnLock = true;
        clearTimeout(turnUnlockTimer);
        try {
          await ensurePagesTurnReady(getEssentialTurnPages(direction), 'standard');
          await waitForBrowserPaint();
          hideOriginalReaderSpread();
          if (direction > 0) pageFlip.flipNext();
          else pageFlip.flipPrev();
        } catch (error) {
          console.error(error);
          turnLock = false;
        } finally {
          turnUnlockTimer = setTimeout(() => {
            turnLock = false;
          }, 900);
        }
      }

      async function jumpToPage(pageNumber, { scrollToViewer = false } = {}) {
        if (!pageFlip || !totalPages) return;
        const target = Math.min(totalPages, Math.max(1, Number(pageNumber) || 1));
        await ensurePagesTurnReady(getPagesAround(target, 3), 'standard');
        await waitForBrowserPaint();
        hideOriginalReaderSpread();
        pageFlip.flip(target - 1);

        // Scroll only when the jump originated outside the reader, such as a
        // Contents or header navigation link. Normal page clicks never move the
        // browser viewport.
        if (scrollToViewer) {
          getById('ayc-ecat-viewer').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }

      function sizeOriginalReaderSpread() {
        const pageHeight = Math.max(1, Number(els.book?.dataset?.pageHeight) || 0);
        if (!bookFrameWidth || !pageHeight) return;

        if (els.originalSpread) {
          els.originalSpread.style.width = `${bookFrameWidth}px`;
          els.originalSpread.style.height = `${pageHeight}px`;
        }

        // Size the independent binding from the actual rendered spread instead of
        // the Shopify section width. The same element remains above both the
        // original-image layer and the animation canvas, eliminating the visible
        // shadow change when a turn begins or ends.
        if (els.persistentSpine) {
          const spineWidth = Math.round(Math.min(82, Math.max(46, bookFrameWidth * 0.052)));
          els.persistentSpine.style.width = `${spineWidth}px`;
          els.persistentSpine.style.height = `${pageHeight}px`;
        }
      }

      function hideOriginalReaderSpread({ clear = false } = {}) {
        originalSpreadToken += 1;
        els.originalSpread?.classList.remove('ayc-ecat-is-visible');
        if (!clear) return;
        originalSpreadKey = '';
        for (const [slot, image] of [
          [els.originalLeft, els.originalLeftImage],
          [els.originalRight, els.originalRightImage],
        ]) {
          slot?.classList.add('ayc-ecat-is-empty');
          if (image) {
            image.removeAttribute('src');
            image.alt = '';
          }
        }
      }

      function getOriginalReaderVisiblePages(pageIndex = null) {
        const index =
          pageIndex == null
            ? pageFlip?.getCurrentPageIndex?.() ?? Math.max(0, currentPage - 1)
            : Math.max(0, Number(pageIndex) || 0);
        const firstPage = Math.min(totalPages, Math.max(1, index + 1));
        const portrait = pageFlip?.getOrientation?.() === 'portrait' || wantsPortraitMode();

        if (portrait) {
          return { portrait: true, left: firstPage, right: null };
        }

        // With showCover enabled, page 1 rests alone on the right. All later
        // spreads use the active page on the left and the following page on the
        // right. The final unmatched page stays on the left.
        if (firstPage === 1) {
          return { portrait: false, left: null, right: 1 };
        }

        return {
          portrait: false,
          left: firstPage,
          right: firstPage < totalPages ? firstPage + 1 : null,
        };
      }

      async function getDecodedOriginalReaderImage(pageNumber) {
        if (!pageNumber) return null;
        // The main reader prefers the normal Shopify file because that is the
        // actual source used for the catalog. A separate HD file remains a
        // fallback and is still preferred by the dedicated zoom viewer.
        const candidates = [
          directPageImageUrls[pageNumber - 1],
          hdPageImageUrls[pageNumber - 1],
          pageElements.get(pageNumber)?.currentUrl,
        ].filter(Boolean);

        let lastError = null;
        for (const url of [...new Set(candidates)]) {
          try {
            return await createDecodedImage(url);
          } catch (error) {
            lastError = error;
          }
        }
        throw lastError || new Error(`No original image is available for page ${pageNumber}.`);
      }

      function applyOriginalReaderSlot(slot, imageElement, pageNumber, decodedImage) {
        if (!slot || !imageElement) return;
        if (!pageNumber || !decodedImage?.src) {
          slot.classList.add('ayc-ecat-is-empty');
          imageElement.removeAttribute('src');
          imageElement.alt = '';
          return;
        }
        imageElement.src = decodedImage.src;
        imageElement.alt = `Catalog page ${pageNumber}`;
        slot.classList.remove('ayc-ecat-is-empty');
      }

      async function syncOriginalReaderSpread(pageIndex = null) {
        if (destroyed || !directImageMode || !pageFlip || !els.originalSpread) {
          hideOriginalReaderSpread();
          return;
        }
        if (pageFlip.getState?.() !== 'read') {
          hideOriginalReaderSpread();
          return;
        }

        const visible = getOriginalReaderVisiblePages(pageIndex);
        const key = `${visible.portrait ? 'portrait' : 'landscape'}:${visible.left || 0}:${visible.right || 0}`;
        sizeOriginalReaderSpread();

        if (originalSpreadKey === key && els.originalSpread.classList.contains('ayc-ecat-is-visible')) {
          return;
        }

        const token = ++originalSpreadToken;
        els.originalSpread.classList.remove('ayc-ecat-is-visible');

        const [leftImage, rightImage] = await Promise.all([
          visible.left ? getDecodedOriginalReaderImage(visible.left) : Promise.resolve(null),
          visible.right ? getDecodedOriginalReaderImage(visible.right) : Promise.resolve(null),
        ]);

        if (destroyed || token !== originalSpreadToken || pageFlip.getState?.() !== 'read') return;

        els.originalSpread.classList.toggle('ayc-ecat-is-portrait', visible.portrait);
        applyOriginalReaderSlot(els.originalLeft, els.originalLeftImage, visible.left, leftImage);
        applyOriginalReaderSlot(els.originalRight, els.originalRightImage, visible.right, rightImage);

        // Decode the actual overlay elements before revealing them. The Canvas
        // remains visible underneath throughout this step, so a slow Shopify CDN
        // response never exposes an empty page.
        await Promise.all(
          [els.originalLeftImage, els.originalRightImage].map(async (image) => {
            if (!image?.src || typeof image.decode !== 'function') return;
            try {
              await image.decode();
            } catch (error) {}
          })
        );

        if (destroyed || token !== originalSpreadToken || pageFlip.getState?.() !== 'read') return;
        originalSpreadKey = key;
        sizeOriginalReaderSpread();
        els.originalSpread.classList.add('ayc-ecat-is-visible');
      }

      function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      function getHdCandidateUrls(pageNumber) {
        const candidates = [
          hdPageImageUrls[pageNumber - 1],
          directPageImageUrls[pageNumber - 1],
          pageElements.get(pageNumber)?.currentUrl,
        ].filter(Boolean);
        return [...new Set(candidates)];
      }

      async function getDecodedHdImage(pageNumber) {
        const cached = hdImageCache.get(pageNumber);
        if (cached?.complete && cached.naturalWidth) return cached;

        const candidates = getHdCandidateUrls(pageNumber);
        if (!candidates.length) {
          throw new Error(`No page image is available for page ${pageNumber}.`);
        }

        let lastError = null;
        for (const url of candidates) {
          try {
            const image = await createDecodedImage(url);
            hdImageCache.set(pageNumber, image);
            return image;
          } catch (error) {
            lastError = error;
            console.warn(`HD candidate failed for page ${pageNumber}: ${url}`, error);
          }
        }
        throw lastError || new Error(`Page ${pageNumber} could not be loaded.`);
      }

      function getHdFitSize() {
        const image = els.hdImage;
        const viewport = els.hdViewport;
        if (!image?.naturalWidth || !image?.naturalHeight || !viewport) {
          return { width: 1, height: 1 };
        }

        const padding = window.innerWidth <= 620 ? 24 : 48;
        const availableWidth = Math.max(1, viewport.clientWidth - padding);
        const availableHeight = Math.max(1, viewport.clientHeight - padding);
        const scale = Math.min(availableWidth / image.naturalWidth, availableHeight / image.naturalHeight, 1);
        return {
          width: Math.max(1, Math.floor(image.naturalWidth * scale)),
          height: Math.max(1, Math.floor(image.naturalHeight * scale)),
        };
      }

      function calculateSafeHdMaxZoom() {
        if (!els.hdImage?.naturalWidth || !hdFitWidth) return 1;
        const effectiveDpr = Math.min(HD_DEVICE_PIXEL_RATIO_CAP, Math.max(1, window.devicePixelRatio || 1));
        const pixelSafeZoom = els.hdImage.naturalWidth / (hdFitWidth * effectiveDpr);
        // Never promise more detail than the source contains. A small allowance
        // above the pixel-safe value keeps controls practical while still avoiding
        // extreme enlargement of a low-resolution page.
        return clamp(Math.max(1, pixelSafeZoom), 1, HD_ABSOLUTE_MAX_ZOOM);
      }

      function updateHdControls() {
        els.hdPageStatus.textContent = `${hdViewerPage} / ${totalPages}`;
        els.hdZoomValue.textContent = `${Math.round(hdViewerZoom * 100)}%`;
        els.hdPrev.disabled = hdViewerPage <= 1;
        els.hdNext.disabled = hdViewerPage >= totalPages;
        els.hdZoomOut.disabled = hdViewerZoom <= 1.001;
        els.hdZoomIn.disabled = hdViewerZoom >= hdViewerMaxZoom - 0.001;
      }

      function applyHdZoom(nextZoom, { preserveCenter = true } = {}) {
        if (!els.hdImage?.naturalWidth || !hdFitWidth || !hdFitHeight) return;
        const viewport = els.hdViewport;
        const previousScrollWidth = Math.max(1, viewport.scrollWidth);
        const previousScrollHeight = Math.max(1, viewport.scrollHeight);
        const centerX = (viewport.scrollLeft + viewport.clientWidth / 2) / previousScrollWidth;
        const centerY = (viewport.scrollTop + viewport.clientHeight / 2) / previousScrollHeight;

        hdViewerZoom = clamp(nextZoom, 1, hdViewerMaxZoom);
        const displayWidth = Math.max(1, Math.round(hdFitWidth * hdViewerZoom));
        const displayHeight = Math.max(1, Math.round(hdFitHeight * hdViewerZoom));
        const canvasWidth = Math.max(viewport.clientWidth, displayWidth + (window.innerWidth <= 620 ? 24 : 48));
        const canvasHeight = Math.max(viewport.clientHeight, displayHeight + (window.innerWidth <= 620 ? 24 : 48));

        els.hdImage.style.width = `${displayWidth}px`;
        els.hdImage.style.height = `${displayHeight}px`;
        els.hdCanvas.style.width = `${canvasWidth}px`;
        els.hdCanvas.style.height = `${canvasHeight}px`;
        els.hdCanvas.style.minWidth = `${canvasWidth}px`;
        els.hdCanvas.style.minHeight = `${canvasHeight}px`;

        requestAnimationFrame(() => {
          if (preserveCenter && hdViewerZoom > 1) {
            viewport.scrollLeft = centerX * viewport.scrollWidth - viewport.clientWidth / 2;
            viewport.scrollTop = centerY * viewport.scrollHeight - viewport.clientHeight / 2;
          } else {
            viewport.scrollLeft = Math.max(0, (viewport.scrollWidth - viewport.clientWidth) / 2);
            viewport.scrollTop = Math.max(0, (viewport.scrollHeight - viewport.clientHeight) / 2);
          }
        });
        updateHdControls();
      }

      function fitHdImage({ resetZoom = false } = {}) {
        if (!els.hdImage?.naturalWidth) return;
        const fit = getHdFitSize();
        hdFitWidth = fit.width;
        hdFitHeight = fit.height;
        hdViewerMaxZoom = calculateSafeHdMaxZoom();
        applyHdZoom(resetZoom ? 1 : Math.min(hdViewerZoom, hdViewerMaxZoom), {
          preserveCenter: !resetZoom,
        });
      }

      function scheduleHdFit(delay = 60) {
        clearTimeout(hdResizeTimer);
        hdResizeTimer = setTimeout(() => {
          if (hdViewerOpen) fitHdImage({ resetZoom: false });
        }, delay);
      }

      function preloadHdNeighbors(pageNumber) {
        for (let offset = -HD_PRELOAD_RADIUS; offset <= HD_PRELOAD_RADIUS; offset += 1) {
          const page = pageNumber + offset;
          if (page < 1 || page > totalPages || page === pageNumber || hdImageCache.has(page)) continue;
          requestIdle(() => {
            getDecodedHdImage(page).catch(() => {
              // A missing HD file is acceptable because the normal page URL is
              // automatically tried as a fallback when that page is opened.
            });
          }, 1500);
        }
      }

      async function showHdPage(pageNumber, { resetZoom = true } = {}) {
        const target = clamp(Math.round(Number(pageNumber) || 1), 1, totalPages);
        const token = ++hdLoadToken;
        els.hdLoadingText.textContent = `Loading page ${target}…`;
        els.hdLoading.classList.add('ayc-ecat-is-visible');

        try {
          const decoded = await getDecodedHdImage(target);
          if (token !== hdLoadToken || !hdViewerOpen) return;

          // Keep the previous page visible until the replacement has fully decoded.
          // Assigning the already-decoded URL avoids a white flash.
          els.hdImage.src = decoded.src;
          els.hdImage.alt = `Catalog page ${target}`;
          hdViewerPage = target;
          await waitForBrowserPaint();
          fitHdImage({ resetZoom });
          updateHdControls();
          preloadHdNeighbors(target);
        } catch (error) {
          console.error(error);
          if (token === hdLoadToken) showToast(`Page ${target} could not be opened in HD`);
        } finally {
          if (token === hdLoadToken) {
            els.hdLoading.classList.remove('ayc-ecat-is-visible');
          }
        }
      }

      async function openHdViewer(pageNumber = currentPage) {
        if (!totalPages || hdViewerOpen) return;
        hdViewerOpen = true;
        hdBodyOverflowBeforeOpen = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        els.root.classList.add('ayc-ecat-hd-open');
        els.hdViewer.hidden = false;
        els.hdClose.focus({ preventScroll: true });
        await showHdPage(pageNumber, { resetZoom: true });
      }

      function closeHdViewer({ syncReader = true } = {}) {
        if (!hdViewerOpen) return;
        hdViewerOpen = false;
        hdLoadToken += 1;
        els.hdViewer.hidden = true;
        els.root.classList.remove('ayc-ecat-hd-open');
        document.body.style.overflow = hdBodyOverflowBeforeOpen;
        els.zoomButton.focus({ preventScroll: true });

        if (syncReader && hdViewerPage !== currentPage) {
          jumpToPage(hdViewerPage).catch(console.error);
        }
      }

      function changeHdPage(direction) {
        const target = clamp(hdViewerPage + direction, 1, totalPages);
        if (target === hdViewerPage) return;
        showHdPage(target, { resetZoom: true });
      }

      function setContentsMessage(message) {
        const item = document.createElement('li');
        item.className = 'ayc-ecat-contents-placeholder';
        item.textContent = message;
        els.contentsList.replaceChildren(item);
      }

      function normalizeCatalogFileName(url, metadataTitle = '') {
        const cleanTitle = String(metadataTitle || '')
          .replace(/[\\/:*?"<>|]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        if (cleanTitle) return `${cleanTitle}.pdf`;

        try {
          const pathname = new URL(url).pathname;
          const lastPart = decodeURIComponent(pathname.split('/').pop() || 'catalog.pdf');
          const safePart = lastPart.replace(/[\\/:*?"<>|]+/g, '-').trim();
          return /\.pdf$/i.test(safePart) ? safePart : `${safePart || 'catalog'}.pdf`;
        } catch (error) {
          return 'catalog.pdf';
        }
      }

      function combineTextItems(items) {
        if (!items.length) return '';
        const ordered = [...items].sort((a, b) => a.x - b.x);
        let text = '';
        let previousRight = null;

        ordered.forEach((item) => {
          const gap = previousRight === null ? 0 : item.x - previousRight;
          if (text && gap > Math.max(2.5, item.fontSize * 0.22)) text += ' ';
          text += item.text;
          previousRight = item.x + item.width;
        });

        return text.replace(/\s+/g, ' ').trim();
      }

      function extractPageLines(pageNumber) {
        if (textLineJobs.has(pageNumber)) return textLineJobs.get(pageNumber);

        const job = (async () => {
          const pdfPage = await pdfDocument.getPage(pageNumber);
          const pageViewport = pdfPage.getViewport({ scale: 1 });
          try {
            const textContent = await pdfPage.getTextContent({
              includeMarkedContent: false,
              disableNormalization: false,
            });

            const textItems = textContent.items
              .filter((item) => item?.str?.trim() && Array.isArray(item.transform))
              .map((item) => ({
                text: item.str.trim(),
                x: Number(item.transform[4]) || 0,
                y: Number(item.transform[5]) || 0,
                width: Number(item.width) || 0,
                fontSize: Math.max(
                  Math.abs(Number(item.transform[0]) || 0),
                  Math.abs(Number(item.transform[3]) || 0),
                  Number(item.height) || 0,
                  1
                ),
              }))
              .sort((a, b) => b.y - a.y || a.x - b.x);

            const grouped = [];
            const yTolerance = 3.5;
            textItems.forEach((item) => {
              let line = grouped.find((candidate) => Math.abs(candidate.y - item.y) <= yTolerance);
              if (!line) {
                line = { y: item.y, items: [] };
                grouped.push(line);
              }
              line.items.push(item);
              line.y = line.items.reduce((sum, current) => sum + current.y, 0) / line.items.length;
            });

            return grouped
              .sort((a, b) => b.y - a.y)
              .map((line) => ({
                text: combineTextItems(line.items),
                x: Math.min(...line.items.map((item) => item.x)),
                y: line.y,
                fontSize: Math.max(...line.items.map((item) => item.fontSize)),
                pageWidth: pageViewport.width,
                pageHeight: pageViewport.height,
              }))
              .filter((line) => line.text);
          } finally {
            pdfPage.cleanup();
          }
        })().catch((error) => {
          textLineJobs.delete(pageNumber);
          throw error;
        });

        textLineJobs.set(pageNumber, job);
        return job;
      }

      function cleanContentsText(value) {
        return String(value || '')
          .replace(/[·•.]{3,}/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function isContentsNoise(text) {
        if (!text) return true;
        if (/^(contents|table of contents|tap to jump)$/i.test(text)) return true;
        if (/^salon furnishings$/i.test(text)) return true;
        if (/www\.|@|\+?\d[\d\s().-]{6,}|volume\s+[xivlcdm]+/i.test(text)) return true;
        if (/^(page|pages|p\.?|catalog)$/i.test(text)) return true;
        return false;
      }

      function parseContentsLine(line) {
        const clean = cleanContentsText(line.text);
        if (isContentsNoise(clean)) return null;

        // This catalog uses the printed page number first, for example:
        // "04  Barber Chairs". Keep support for title-first Contents pages too.
        let match = clean.match(/^(?:p\.?\s*)?(\d{1,4})\s+(.{2,})$/i);
        if (match) {
          const printedLabel = match[1];
          const printedPage = Number(printedLabel);
          const title = String(match[2] || '')
            .replace(/^[-–—|:\s]+|[-–—|:\s]+$/g, '')
            .trim();
          if (title && Number.isFinite(printedPage) && printedPage >= 1) {
            return {
              kind: 'item',
              title,
              printedPage,
              printedLabel,
              x: line.x,
              y: line.y,
              fontSize: line.fontSize,
            };
          }
        }

        match = clean.match(/^(.{2,}?)\s+(?:p\.?\s*)?(\d{1,4})$/i);
        if (match) {
          const printedLabel = match[2];
          const printedPage = Number(printedLabel);
          const title = String(match[1] || '')
            .replace(/^[-–—|:\s]+|[-–—|:\s]+$/g, '')
            .trim();
          if (title && Number.isFinite(printedPage) && printedPage >= 1) {
            return {
              kind: 'item',
              title,
              printedPage,
              printedLabel,
              x: line.x,
              y: line.y,
              fontSize: line.fontSize,
            };
          }
        }

        // A standalone text line on a Contents page is treated as a section
        // heading, such as Berkeley, Mayakoba, Dermalogic, Keen Essentials or Parts.
        if (
          clean.length >= 2 &&
          clean.length <= 80 &&
          /[A-Za-z]/.test(clean) &&
          !/\d/.test(clean) &&
          !/[.!?;:]$/.test(clean)
        ) {
          return {
            kind: 'heading',
            title: clean,
            x: line.x,
            y: line.y,
            fontSize: line.fontSize,
          };
        }

        return null;
      }

      async function buildPageLabelLookup() {
        const lookup = new Map();
        try {
          const labels = await pdfDocument.getPageLabels();
          if (labels?.length) {
            labels.forEach((label, index) => {
              const normalized = String(label || '')
                .trim()
                .toLowerCase();
              if (normalized && !lookup.has(normalized)) lookup.set(normalized, index + 1);
              const numeric = normalized.match(/\d+/)?.[0];
              if (numeric && !lookup.has(numeric)) lookup.set(numeric, index + 1);
            });
          }
        } catch (error) {
          console.warn('catalog page labels could not be read', error);
        }
        return lookup;
      }

      function extractFooterPageNumbers(lines) {
        const numbers = new Set();

        lines.forEach((line) => {
          if (!line.pageHeight || line.y > line.pageHeight * 0.18) return;
          const text = cleanContentsText(line.text);
          if (!text) return;

          const exact = text.match(/^0*(\d{1,3})$/);
          const atStart = text.match(/^0*(\d{1,3})(?=\s|[|/·•—–-])/);
          const atEnd = text.match(/(?:\s|[|/·•—–-])0*(\d{1,3})$/);

          [exact, atStart, atEnd].forEach((match) => {
            const value = Number(match?.[1]);
            if (Number.isFinite(value) && value >= 1 && value <= totalPages + 20) {
              numbers.add(value);
            }
          });
        });

        return numbers;
      }

      async function detectPrintedPageOffset(candidates, labelLookup) {
        const numbered = candidates.filter((item) => item.kind === 'item');
        if (!numbered.length) return 0;

        // Explicit PDF Page Labels are authoritative and do not need an offset.
        if (numbered.some((item) => labelLookup.has(String(item.printedPage)))) return 0;

        const distinctPages = [...new Set(numbered.map((item) => item.printedPage))];
        const samples = distinctPages.slice(0, 3);
        const scores = new Map();

        for (const printedPage of samples) {
          for (let offset = -2; offset <= 8; offset += 1) {
            const pdfPage = printedPage + offset;
            if (pdfPage < 1 || pdfPage > (pdfDocument?.numPages || totalPages)) continue;

            const lines = await extractPageLines(pdfPage);
            const footerNumbers = extractFooterPageNumbers(lines);
            if (footerNumbers.has(printedPage)) {
              scores.set(offset, (scores.get(offset) || 0) + 1);
            }
          }
        }

        if (!scores.size) return 0;
        return [...scores.entries()].sort((a, b) => b[1] - a[1] || Math.abs(a[0]) - Math.abs(b[0]))[0][0];
      }

      function mapPrintedPageToPdfPage(printedPage, labelLookup, pageOffset = 0) {
        const fromLabel = labelLookup.get(String(printedPage));
        if (fromLabel) return fromLabel;
        return Math.min(totalPages, Math.max(1, printedPage + pageOffset));
      }

      function buildContentsGroups(candidates, labelLookup, pageOffset = 0) {
        const groups = [];
        const looseItems = [];
        const seen = new Set();
        let activeGroup = null;

        candidates.forEach((candidate) => {
          if (candidate.kind === 'heading') {
            activeGroup = {
              title: candidate.title,
              page: null,
              pageLabel: '',
              children: [],
            };
            groups.push(activeGroup);
            return;
          }

          if (candidate.kind !== 'item') return;
          const key = `${candidate.title.toLowerCase()}|${candidate.printedPage}`;
          if (seen.has(key)) return;
          seen.add(key);

          const child = {
            title: candidate.title,
            page: mapPrintedPageToPdfPage(candidate.printedPage, labelLookup, pageOffset),
            pageLabel: candidate.printedLabel || String(candidate.printedPage),
            children: [],
          };

          if (activeGroup) {
            activeGroup.children.push(child);
          } else {
            looseItems.push(child);
          }
        });

        // Remove false standalone headings that did not receive any numbered rows.
        const populatedGroups = groups.filter((group) => group.children.length > 0);
        populatedGroups.forEach((group) => {
          group.page = group.children[0].page;
          group.pageLabel = group.children[0].pageLabel;
        });

        if (looseItems.length) {
          populatedGroups.unshift({
            title: 'Catalog',
            page: looseItems[0].page,
            pageLabel: looseItems[0].pageLabel,
            children: looseItems,
          });
        }

        return populatedGroups;
      }

      async function extractContentsFromPdf() {
        const pdfPageCount = pdfDocument?.numPages || 0;
        const scanLimit = Math.min(pdfPageCount, 24);
        const maxContentsPages = 1;
        let contentsPageNumber = null;
        let contentsPageLines = null;

        for (let pageNumber = 1; pageNumber <= scanLimit; pageNumber += 1) {
          setContentsMessage(`Looking for the Contents page… ${pageNumber} / ${scanLimit}`);
          const lines = await extractPageLines(pageNumber);
          const hasContentsHeading = lines.some((line) => {
            const text = cleanContentsText(line.text);
            return text.length <= 80 && /^(?:table of )?contents(?:\s*[:|—-].*)?$/i.test(text);
          });

          if (hasContentsHeading) {
            contentsPageNumber = pageNumber;
            contentsPageLines = lines;
            break;
          }
        }

        if (!contentsPageNumber) return [];

        const labelLookup = await buildPageLabelLookup();
        const candidates = [];

        for (
          let pageNumber = contentsPageNumber;
          pageNumber <= Math.min(pdfPageCount, contentsPageNumber + maxContentsPages - 1);
          pageNumber += 1
        ) {
          const lines = pageNumber === contentsPageNumber ? contentsPageLines : await extractPageLines(pageNumber);
          const parsedLines = lines.map(parseContentsLine).filter(Boolean);
          const numberedRows = parsedLines.filter((item) => item.kind === 'item');

          // Read the detected Contents page itself. This avoids treating product
          // pages that follow it as additional Contents rows.
          if (pageNumber > contentsPageNumber && numberedRows.length === 0) break;
          candidates.push(...parsedLines);
        }

        const pageOffset = await detectPrintedPageOffset(candidates, labelLookup);
        return buildContentsGroups(candidates, labelLookup, pageOffset);
      }

      async function regenerateContents() {
        setContentsMessage('Reading the PDF Contents page…');
        await new Promise((resolve) => requestAnimationFrame(resolve));

        const contents = await extractContentsFromPdf();
        if (contents.length && renderOutlineContents(contents)) {
          return 'contents-page';
        }

        setContentsMessage(
          'No readable Contents page was found in the first 24 catalog pages. ' +
            'The Contents page must contain selectable text, section headings, and numbered rows such as ‘04 Barber Chairs’.'
        );
        renderOutlineNavigation([]);
        return 'not-found';
      }

      function flattenOutlineChildren(items, depth = 1, output = []) {
        items.forEach((item) => {
          if (item.page) {
            output.push({
              title: item.title,
              page: item.page,
              pageLabel: item.pageLabel || String(item.page),
              depth,
            });
          }
          if (item.children?.length) {
            flattenOutlineChildren(item.children, depth + 1, output);
          }
        });
        return output;
      }

      function createPageButton(className, title, page, prefix = '', displayPage = page) {
        const button = document.createElement('button');
        button.className = className;
        button.type = 'button';
        button.dataset.page = String(page);

        const name = document.createElement('span');
        name.className = 'ayc-ecat-contents-name';
        name.textContent = title;

        const pageLabel = document.createElement('span');
        pageLabel.className = 'ayc-ecat-contents-page';
        pageLabel.textContent = `${prefix}${displayPage}`;

        button.append(name, pageLabel);
        return button;
      }

      function renderOutlineNavigation(outline) {
        if (!els.catalogNav) return;
        els.catalogNav.querySelectorAll('[data-page]').forEach((link) => link.remove());
        const activeLink = els.catalogNav.querySelector('.ayc-ecat-active');

        outline.slice(0, 4).forEach((item) => {
          if (!item.page) return;
          const link = document.createElement('a');
          link.href = '#ayc-ecat-viewer';
          link.dataset.page = String(item.page);
          link.textContent = item.title;
          els.catalogNav.insertBefore(link, activeLink);
        });
      }

      function renderOutlineContents(outline) {
        els.contentsList.replaceChildren();

        outline.forEach((group, index) => {
          if (!group.page) return;

          const row = document.createElement('li');
          row.className = 'ayc-ecat-contents-group';

          const number = document.createElement('span');
          number.className = 'ayc-ecat-section-number';
          number.textContent = String(index + 1).padStart(2, '0');

          const main = document.createElement('div');
          main.className = 'ayc-ecat-contents-main';
          main.append(
            createPageButton(
              'ayc-ecat-contents-group-title',
              group.title,
              group.page,
              'p. ',
              group.pageLabel || group.page
            )
          );

          const childItems = flattenOutlineChildren(group.children || []);
          if (childItems.length) {
            const itemsWrap = document.createElement('div');
            itemsWrap.className = 'ayc-ecat-contents-items';

            childItems.forEach((item) => {
              const button = createPageButton(
                'ayc-ecat-contents-item',
                item.title,
                item.page,
                '',
                item.pageLabel || item.page
              );
              const name = button.querySelector('.ayc-ecat-contents-name');
              name.style.paddingLeft = `${Math.max(0, item.depth - 1) * 16}px`;
              itemsWrap.append(button);
            });
            main.append(itemsWrap);
          }

          row.append(number, main);
          els.contentsList.append(row);
        });

        const hasContents = els.contentsList.children.length > 0;
        if (hasContents) renderOutlineNavigation(outline);
        return hasContents;
      }

      async function loadPdfDocument(pdfUrl, { showProgress = false } = {}) {
        const pdfjs = await getPdfJs();
        const loadingTask = pdfjs.getDocument({
          url: pdfUrl,
          cMapPacked: true,
          enableXfa: true,
        });

        loadingTask.onProgress = ({ loaded, total }) => {
          downloadedBytes = Math.max(downloadedBytes, total || loaded || 0);
          els.fileSize.textContent = formatBytes(downloadedBytes);
          if (showProgress && total) {
            const percent = Math.round((loaded / total) * 100);
            els.stateMessage.textContent = `Downloading PDF · ${percent}%`;
          }
        };

        return loadingTask.promise;
      }

      async function loadPdfSupportInBackground(pdfUrl) {
        if (!pdfUrl || pdfSupportLoading) return pdfSupportLoading;
        pdfSupportLoading = (async () => {
          try {
            const document = await loadPdfDocument(pdfUrl, { showProgress: false });
            pdfDocument = document;

            if (directImageMode && document.numPages !== totalPages) {
              console.warn(
                `The PDF has ${document.numPages} pages, but ${totalPages} page images are configured. ` +
                  'Contents links work best when both counts match.'
              );
            }

            try {
              const metadata = await document.getMetadata();
              catalogFileName =
                configuredDownloadFileName ||
                normalizeCatalogFileName(pdfUrl, metadata?.info?.Title || metadata?.metadata?.get?.('dc:title') || '');
            } catch (error) {
              console.warn('PDF metadata could not be read', error);
            }

            els.printButton.disabled = false;
            els.downloadButton.disabled = false;
            await regenerateContents();
            return document;
          } catch (error) {
            console.error('Optional PDF support could not be loaded', error);
            setContentsMessage(
              'The page images loaded, but the optional PDF could not be read for Contents. ' +
                'Check the pdf value in the active catalog.json and its CORS settings.'
            );
            return null;
          }
        })();
        return pdfSupportLoading;
      }

      async function loadCatalog() {
        els.stateTitle.textContent = 'Loading catalog configuration';
        els.stateMessage.textContent = 'Checking the active catalog version.';

        try {
          await loadActiveCatalogConfiguration();
          directPageImageUrls = buildConfiguredPageImageUrls();
          hdPageImageUrls = buildConfiguredHdPageImageUrls();
        } catch (error) {
          console.error('Catalog configuration could not be loaded', error);
          const localHint =
            location.protocol === 'file:'
              ? ' Run a local HTTP server; browsers normally block JSON fetches from file:// pages.'
              : '';
          setError(`${error.message}${localHint}`);
          return;
        }
        directImageMode = directPageImageUrls.length > 0;

        if (!directImageMode && !PDF_URL.trim()) {
          els.stateTitle.textContent = 'Add a catalog source';
          els.stateMessage.innerHTML =
            'The active catalog configuration does not contain a pageImageTemplate/pageImageUrls source. ' +
            'Update the version catalog.json file.';
          return;
        }

        let pdfUrl = '';
        if (PDF_URL.trim()) {
          try {
            pdfUrl = normalizeUrl(PDF_URL.trim(), 'PDF_URL');
            resolvedPdfUrl = pdfUrl;
            catalogFileName = configuredDownloadFileName || normalizeCatalogFileName(pdfUrl);
          } catch (error) {
            setError(error.message);
            return;
          }
        }

        els.stateTitle.textContent = 'Loading catalog';
        els.stateMessage.textContent = directImageMode
          ? 'Loading the first page image.'
          : 'Downloading the PDF and preparing the page-turning reader.';

        try {
          await waitForPageFlip();

          if (directImageMode) {
            totalPages = directPageImageUrls.length;
            if (hdPageImageUrls.length && hdPageImageUrls.length !== totalPages) {
              console.warn(
                `The HD source has ${hdPageImageUrls.length} pages, but the normal source has ${totalPages}. ` +
                  'Missing HD pages will fall back to the normal page images.'
              );
            }
            let firstImage;
            try {
              firstImage = await createDecodedImage(directPageImageUrls[0]);
            } catch (error) {
              const expected = String(activeCatalogConfig?.expectedFirstFilename || '').trim();
              const suffix = expected
                ? ` Check that Content > Files contains the exact file: ${expected}`
                : ' Check the catalog prefix, filename middle, number padding, and image format.';
              throw new Error(`The first catalog page could not be loaded.${suffix}`);
            }
            if (!firstImage.naturalWidth || !firstImage.naturalHeight) {
              throw new Error('The first catalog page image has invalid dimensions.');
            }
            pageRatio = firstImage.naturalWidth / firstImage.naturalHeight;
            renderHeight = 900;
            renderWidth = Math.max(360, Math.round(renderHeight * pageRatio));
            els.fileSize.textContent = 'Images';
          } else {
            pdfDocument = await loadPdfDocument(pdfUrl, { showProgress: true });
            totalPages = pdfDocument.numPages;
            if (!totalPages) throw new Error('The PDF contains no pages.');

            try {
              const metadata = await pdfDocument.getMetadata();
              catalogFileName =
                configuredDownloadFileName ||
                normalizeCatalogFileName(pdfUrl, metadata?.info?.Title || metadata?.metadata?.get?.('dc:title') || '');
            } catch (error) {
              console.warn('PDF metadata could not be read', error);
            }

            const firstPage = await pdfDocument.getPage(1);
            const viewport = firstPage.getViewport({ scale: 1 });
            pageRatio = viewport.width / viewport.height;
            renderHeight = 900;
            renderWidth = Math.max(360, Math.round(renderHeight * pageRatio));
            firstPage.cleanup();
          }

          els.pageCount.textContent = String(totalPages);
          els.pageRange.max = String(totalPages);
          els.pageRange.value = '1';
          updateRangeProgress(1);

          applyBookFrameSize({ force: true });
          await waitForBrowserPaint();
          applyBookFrameSize({ force: true });

          for (let page = 1; page <= totalPages; page += 1) makePageElement(page);

          initializePageImageUrls();
          await preloadInitialPages();
          await waitForBrowserPaint();

          const initialPortrait = wantsPortraitMode();
          const initialMinWidth = initialPortrait ? Math.max(100, Math.ceil(bookFrameWidth * 0.62)) : 100;

          pageFlip = new window.St.PageFlip(els.book, {
            width: renderWidth,
            height: renderHeight,
            size: 'stretch',
            minWidth: initialMinWidth,
            maxWidth: 4096,
            minHeight: Math.max(140, Math.round(initialMinWidth / pageRatio)),
            maxHeight: 4096,
            maxShadowOpacity: 0.16,
            showCover: true,
            mobileScrollSupport: false,
            usePortrait: true,
            autoSize: false,
            drawShadow: true,
            flippingTime: 500,
            startZIndex: 10,
            showPageCorners: true,
            disableFlipByClick: false,
          });

          pageFlip.loadFromImages(pageImageUrls);
          for (const record of pageElements.values()) {
            if (record.currentUrl && pageImageUrls[record.pageNumber - 1] === record.currentUrl) {
              record.collectionUrl = record.currentUrl;
            }
          }
          applyResponsivePageFlipSettings();
          pageFlip.getUI?.()?.update?.();
          pageFlip.update?.();
          configureCanvasRenderSurface();
          pageFlip.getRender?.().update?.();
          pageFlip.on('flip', (event) => updateNavigation(event.data));
          pageFlip.on('changeState', async (event) => {
            const isReading = event.data === 'read';
            els.root.classList.toggle('ayc-ecat-is-turning', !isReading);
            if (!isReading) {
              hideOriginalReaderSpread();
              return;
            }

            turnLock = false;
            clearTimeout(turnUnlockTimer);
            await flushPendingCanvasPatches();
            renderNearby(pageFlip.getCurrentPageIndex() + 1);
            settleBookAfterTurn();
            await syncOriginalReaderSpread(pageFlip.getCurrentPageIndex());
            if (layoutSyncPending) scheduleBookLayoutSync(0);
          });
          pageFlip.on('changeOrientation', () => {
            hideOriginalReaderSpread();
            requestAnimationFrame(() => updateNavigation(pageFlip.getCurrentPageIndex()));
          });

          if ('ResizeObserver' in window) {
            bookResizeObserver?.disconnect?.();
            bookResizeObserver = new ResizeObserver(() => {
              const rect = els.bookStage.getBoundingClientRect();
              const width = Math.round(rect.width);
              const height = Math.round(rect.height);
              if (Math.abs(width - lastObservedStageWidth) < 1 && Math.abs(height - lastObservedStageHeight) < 1)
                return;
              lastObservedStageWidth = width;
              lastObservedStageHeight = height;
              scheduleBookLayoutSync(40);
            });
            [els.root, els.viewerShell, els.bookRow, els.bookStage]
              .filter(Boolean)
              .forEach((element) => bookResizeObserver.observe(element));
          }

          setTimeout(() => scheduleBookLayoutSync(0), 80);
          setTimeout(() => scheduleBookLayoutSync(0), 450);
          setTimeout(() => scheduleBookLayoutSync(0), 1200);

          els.root.classList.add('ayc-ecat-viewer-ready');
          els.prevButton.disabled = true;
          els.nextButton.disabled = totalPages <= 1;
          els.pageRange.disabled = false;
          els.zoomButton.disabled = false;
          els.fullscreenButton.disabled = false;
          els.printButton.disabled = !pdfUrl;
          els.downloadButton.disabled = !pdfUrl;
          updateNavigation(0);
          setTimeout(startBackgroundPreload, 1800);

          if (directImageMode) {
            if (pdfUrl) {
              setContentsMessage('Page images are ready. Loading Contents from the PDF shortly…');
              setTimeout(() => loadPdfSupportInBackground(pdfUrl), 2000);
            } else {
              setContentsMessage(
                'Direct page images are active. The zoom button uses pages-hd when available and falls back to pages. Add pdf to the active catalog.json only for automatic Contents, Print, or Download.'
              );
              renderOutlineNavigation([]);
            }
          } else {
            els.printButton.disabled = false;
            els.downloadButton.disabled = false;
            await regenerateContents();
          }
        } catch (error) {
          console.error(error);
          const rawMessage = String(error?.message || error || 'Unknown error');
          const corsMessage = /fetch|network|cors|response|failed|image/i.test(rawMessage)
            ? ' The source server may not allow access, or an image filename may be incorrect.'
            : '';
          setError(rawMessage + corsMessage);
        }
      }

      els.bookStage.addEventListener(
        'pointerdown',
        (event) => {
          els.root.focus({ preventScroll: true });
          if (!pageFlip || event.button > 0) return;

          const rect = els.book.getBoundingClientRect();
          const direction = event.clientX >= rect.left + rect.width / 2 ? 1 : -1;
          const pages = getEssentialTurnPages(direction);

          // Never let StPageFlip reveal a placeholder sheet. When the destination
          // spread is not ready, consume this first gesture, render the real pages,
          // and then perform the same turn programmatically.
          if (!arePagesRendered(pages)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            prepareAndFlip(direction).catch(console.error);
            return;
          }

          primeTurn(direction);
        },
        { capture: true, passive: false }
      );

      els.bookStage.addEventListener(
        'touchstart',
        (event) => {
          if (!pageFlip || !event.touches?.length) return;
          const touch = event.touches[0];
          const rect = els.book.getBoundingClientRect();
          const direction = touch.clientX >= rect.left + rect.width / 2 ? 1 : -1;
          const pages = getEssentialTurnPages(direction);
          if (!arePagesRendered(pages)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            prepareAndFlip(direction).catch(console.error);
          }
        },
        { capture: true, passive: false }
      );

      els.bookStage.addEventListener(
        'pointermove',
        (event) => {
          if (!pageFlip) return;
          const rect = els.bookStage.getBoundingClientRect();
          primeTurn(event.clientX >= rect.left + rect.width / 2 ? 1 : -1);
        },
        { passive: true }
      );

      els.prevButton.addEventListener('click', () => flipSafely(-1));
      els.nextButton.addEventListener('click', () => flipSafely(1));

      els.pageRange.addEventListener('input', () => {
        const previewPage = Number(els.pageRange.value);
        els.pageStatus.textContent = `${previewPage} / ${totalPages}`;
        updateRangeProgress(previewPage);
      });

      els.pageRange.addEventListener('change', () => jumpToPage(els.pageRange.value));

      window.addEventListener(
        'pagehide',
        () => {
          for (const url of pageObjectUrls) URL.revokeObjectURL(url);
          pageObjectUrls.clear();
          hdImageCache.clear();
          if (hdViewerOpen) closeHdViewer({ syncReader: false });
        },
        { once: true, signal: lifecycleController.signal }
      );

      els.printButton.addEventListener('click', () => {
        if (!resolvedPdfUrl) return;
        window.open(resolvedPdfUrl, '_blank', 'noopener,noreferrer');
      });

      els.downloadButton.addEventListener('click', async () => {
        if (!pdfDocument && !resolvedPdfUrl) return;
        els.downloadButton.disabled = true;

        try {
          if (pdfDocument) {
            const bytes = await pdfDocument.getData();
            const blob = new Blob([bytes], { type: 'application/pdf' });
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = catalogFileName || 'catalog.pdf';
            document.body.append(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
            showToast('PDF download started');
          } else {
            const link = document.createElement('a');
            link.href = resolvedPdfUrl;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.download = catalogFileName || 'catalog.pdf';
            document.body.append(link);
            link.click();
            link.remove();
            showToast('PDF download opened');
          }
        } catch (error) {
          console.error(error);
          if (resolvedPdfUrl) {
            window.open(resolvedPdfUrl, '_blank', 'noopener,noreferrer');
            showToast('Opened the PDF in a new tab');
          } else {
            showToast('The PDF could not be downloaded');
          }
        } finally {
          els.downloadButton.disabled = false;
        }
      });

      els.copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(window.location.href);
          showToast('Catalog link copied');
        } catch (error) {
          showToast('Copy the URL from your browser address bar');
        }
      });

      els.zoomButton.addEventListener('click', () => openHdViewer(currentPage));
      els.hdClose.addEventListener('click', () => closeHdViewer());
      els.hdPrev.addEventListener('click', () => changeHdPage(-1));
      els.hdNext.addEventListener('click', () => changeHdPage(1));
      els.hdZoomOut.addEventListener('click', () => applyHdZoom(hdViewerZoom - HD_ZOOM_STEP));
      els.hdZoomIn.addEventListener('click', () => applyHdZoom(hdViewerZoom + HD_ZOOM_STEP));
      els.hdReset.addEventListener('click', () => applyHdZoom(1, { preserveCenter: false }));

      els.hdImage.addEventListener('dblclick', (event) => {
        event.preventDefault();
        const targetZoom = hdViewerZoom > 1.05 ? 1 : Math.min(2, hdViewerMaxZoom);
        applyHdZoom(targetZoom, { preserveCenter: false });
      });

      els.hdViewport.addEventListener(
        'wheel',
        (event) => {
          if (!hdViewerOpen || (!event.ctrlKey && !event.metaKey)) return;
          event.preventDefault();
          const direction = event.deltaY < 0 ? 1 : -1;
          applyHdZoom(hdViewerZoom + direction * HD_ZOOM_STEP);
        },
        { passive: false }
      );

      els.hdViewport.addEventListener('pointerdown', (event) => {
        if (!hdViewerOpen || event.button > 0 || hdViewerZoom <= 1.001) return;
        hdPanState = {
          pointerId: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          scrollLeft: els.hdViewport.scrollLeft,
          scrollTop: els.hdViewport.scrollTop,
        };
        els.hdViewport.classList.add('ayc-ecat-is-panning');
        els.hdViewport.setPointerCapture?.(event.pointerId);
        event.preventDefault();
      });

      els.hdViewport.addEventListener('pointermove', (event) => {
        if (!hdPanState || hdPanState.pointerId !== event.pointerId) return;
        els.hdViewport.scrollLeft = hdPanState.scrollLeft - (event.clientX - hdPanState.x);
        els.hdViewport.scrollTop = hdPanState.scrollTop - (event.clientY - hdPanState.y);
        event.preventDefault();
      });

      function stopHdPan(event) {
        if (!hdPanState || (event?.pointerId != null && hdPanState.pointerId !== event.pointerId)) return;
        hdPanState = null;
        els.hdViewport.classList.remove('ayc-ecat-is-panning');
      }

      els.hdViewport.addEventListener('pointerup', stopHdPan);
      els.hdViewport.addEventListener('pointercancel', stopHdPan);
      els.hdViewport.addEventListener('lostpointercapture', stopHdPan);

      document.addEventListener(
        'keydown',
        (event) => {
          if (!hdViewerOpen) return;
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            closeHdViewer();
            return;
          }
          if (event.key === 'ArrowLeft' || event.key === 'PageUp') {
            event.preventDefault();
            changeHdPage(-1);
          } else if (event.key === 'ArrowRight' || event.key === 'PageDown') {
            event.preventDefault();
            changeHdPage(1);
          } else if (event.key === '+' || event.key === '=') {
            event.preventDefault();
            applyHdZoom(hdViewerZoom + HD_ZOOM_STEP);
          } else if (event.key === '-' || event.key === '_') {
            event.preventDefault();
            applyHdZoom(hdViewerZoom - HD_ZOOM_STEP);
          } else if (event.key === '0') {
            event.preventDefault();
            applyHdZoom(1, { preserveCenter: false });
          }
        },
        { capture: true, signal: lifecycleController.signal }
      );

      els.viewerSection = getById('ayc-ecat-viewer');
      els.fullscreenButton.addEventListener('click', async () => {
        if (document.fullscreenElement) {
          await document.exitFullscreen().catch(() => {});
          return;
        }
        try {
          await els.viewerSection.requestFullscreen();
        } catch (error) {
          showToast('Fullscreen is not supported in this browser');
        }
      });

      function handleFullscreenLayoutChange() {
        const active = isViewerFullscreen();
        els.root.classList.toggle('ayc-ecat-is-fullscreen', active);
        // Fullscreen geometry can settle over several animation frames, especially
        // on mobile Safari and Chromium with browser UI collapsing. Recalculate
        // immediately and again after the fullscreen viewport has stabilized.
        scheduleBookLayoutSync(0);
        setTimeout(() => scheduleBookLayoutSync(0), 90);
        setTimeout(() => scheduleBookLayoutSync(0), 260);
        if (hdViewerOpen) {
          scheduleHdFit(0);
          setTimeout(() => scheduleHdFit(0), 180);
        }
      }

      document.addEventListener('fullscreenchange', handleFullscreenLayoutChange, {
        signal: lifecycleController.signal,
      });
      document.addEventListener('webkitfullscreenchange', handleFullscreenLayoutChange, {
        signal: lifecycleController.signal,
      });

      els.root.addEventListener('click', (event) => {
        // Only navigation controls are allowed to trigger a catalog jump.
        // Flipbook pages deliberately use data-pdf-page instead of data-page.
        const pageTarget = event.target.closest('#ayc-ecat-catalog-nav [data-page], #ayc-ecat-contents [data-page]');
        if (!pageTarget) return;
        event.preventDefault();
        jumpToPage(pageTarget.dataset.page, { scrollToViewer: true });
      });

      els.root.addEventListener('keydown', (event) => {
        if (hdViewerOpen) return;
        if (!pageFlip || /INPUT|TEXTAREA|SELECT/.test(document.activeElement?.tagName)) return;
        if (event.key === 'ArrowLeft' || event.key === 'PageUp') {
          event.preventDefault();
          flipSafely(-1);
        }
        if (event.key === 'ArrowRight' || event.key === 'PageDown' || event.key === ' ') {
          event.preventDefault();
          flipSafely(1);
        }
        if (event.key === 'Home') jumpToPage(1);
        if (event.key === 'End') jumpToPage(totalPages);
      });

      window.addEventListener(
        'resize',
        () => {
          scheduleBookLayoutSync(50);
          if (hdViewerOpen) scheduleHdFit(50);
        },
        { passive: true, signal: lifecycleController.signal }
      );
      window.addEventListener(
        'orientationchange',
        () => {
          scheduleBookLayoutSync(80);
          if (hdViewerOpen) scheduleHdFit(100);
        },
        { passive: true, signal: lifecycleController.signal }
      );
      window.visualViewport?.addEventListener(
        'resize',
        () => {
          scheduleBookLayoutSync(50);
          if (hdViewerOpen) scheduleHdFit(50);
        },
        { passive: true, signal: lifecycleController.signal }
      );
      document.addEventListener(
        'visibilitychange',
        () => {
          if (!document.hidden) scheduleBookLayoutSync(0);
        },
        { signal: lifecycleController.signal }
      );

      function destroyCatalogInstance() {
        if (destroyed) return;
        destroyed = true;
        lifecycleController.abort();
        bookResizeObserver?.disconnect?.();
        try {
          pageFlip?.destroy?.();
        } catch (error) {}
        for (const url of pageObjectUrls) URL.revokeObjectURL(url);
        pageObjectUrls.clear();
        hdImageCache.clear();
        hideOriginalReaderSpread({ clear: true });
        if (hdViewerOpen) {
          try {
            closeHdViewer({ syncReader: false });
          } catch (error) {}
        }
        if (registry.get(sectionKey)?.root === els.root) registry.delete(sectionKey);
      }

      registry.set(sectionKey, { root: els.root, destroy: destroyCatalogInstance });
      loadCatalog().catch((error) => {
        if (!destroyed) {
          console.error(error);
          setError(String(error?.message || error || 'Catalog initialization failed.'));
        }
      });
    }

    function initializeAllAycCatalogs(scope = document) {
      const wrappers = scope.matches?.('.section-ayc-e-catalog')
        ? [scope]
        : [...(scope.querySelectorAll?.('.section-ayc-e-catalog') || [])];
      wrappers.forEach(initializeAycCatalog);
    }

    function boot() {
      initializeAllAycCatalogs(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target?.matches?.('.section-ayc-e-catalog')) {
        initializeAycCatalog(event.target);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target?.querySelector?.('[data-ayc-ecat-root]');
      const key = root?.dataset?.sectionId || event.target?.id;
      if (key) registry.get(key)?.destroy?.();
    });

    async function loadQrLinkMap() {
      const url = els.root.dataset.aycQrMapUrl;

      if (!url) return {};

      const response = await fetch(url, {
        cache: "force-cache"
      });

      if (!response.ok) {
        throw new Error("QR link map could not be loaded.");
      }

      return response.json();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
